const tr = {

    "Finance": "Finans",
    "Invoicing": "Faturalandırma",
    "Manual Invoices": "Manuel Faturalar",
    "Payable": "Borçlar",
    "Financial Records": "Finansal Kayıtlar",
    "Invoice Records": "Fatura Kayıtları",
    "Create Account": "Hesap Oluştur",
    "Account List": "Hesap Listesi",


    "All Credit Risks": "Tüm Kredi Riskleri",
    "Normal": "Normal",
    "Overdue": "Vadesi Geçmiş",
    "Doubtful": "Şüpheli",
    "Bad Debt": "Değersiz Alacak",
    "Written Off": "Kayıttan Düşülmüş",
    "Open collection risk details": "Tahsilat risk detaylarını aç",
    "Domestic": "Yurtiçi",
    "International": "Uluslararası",
    "Manual": "Manuel",
    "Other": "Diğer",
    "Unspecified": "Belirtilmemiş",
    "Financial performance chart": "Finansal performans grafiği",
    "financial summary": "finansal özet",
    "Net profit": "Net kâr",
    "invoice": "fatura",
    "invoices": "fatura",
    "jobs": "iş",
    "records": "kayıt",
    "total records": "toplam kayıt",
    "Revenue": "Gelir",
    "Cost": "Maliyet",
    "Collected": "Tahsil Edilen",
    "Profit": "Kâr",
    "Margin": "Marj",
    "MONTH": "AY",
    "NET REVENUE": "NET GELİR",
    "ISSUED RETURNS": "KESİLEN İADELER",
    "EXPENSE / COST": "GİDER / MALİYET",
    "STATUS / PROFIT": "DURUM / KÂR",
    "MARGIN": "MARJ",
    "TOTAL": "TOPLAM",
    "Gross": "Brüt",
    "Revenue reduction": "Gelir düşüşü",
    "Supplier + operation cost": "Tedarikçi + operasyon maliyeti",
    "Monthly Revenue / Returns / Expense": "Aylık Gelir / İade / Gider",
    "Gross selling, issued returns, net revenue, cost and profitability through the current month": "Brüt satış, kesilen iadeler, net gelir, maliyet ve mevcut aya kadar kârlılık",
    "Report Currency": "Rapor Para Birimi",
    "Export to Excel": "Excel'e Aktar",
    "Current Exchange Rates": "Güncel Döviz Kurları",
    "Last updated": "Son güncelleme",
    "Exchange rate information unavailable": "Döviz kuru bilgisi mevcut değil",
    "CORPORATE FINANCE CONTROL CENTER": "KURUMSAL FİNANS KONTROL MERKEZİ",
    "Financial Command Center": "Finans Yönetim Merkezi",
    "A banking-grade overview of revenue, profitability, liquidity, collections, supplier exposure and finance operations.": "Gelir, kârlılık, likidite, tahsilatlar, tedarikçi yükümlülükleri ve finans operasyonlarının kurumsal genel görünümü.",
    "System operational": "Sistem aktif",
    "Updated": "Güncellendi",
    "Update": "Güncelle",
    "Only": "Yalnızca",
    "accounts are shown.": "hesapları gösterilir.",
    "Select source account first.": "Önce kaynak hesabı seçin.",
    "Credit Card Payment": "Kredi Kartı Ödemesi",
    "POS Settlement": "POS Mutabakatı",
    "Cheque Collection": "Çek Tahsilatı",
    "Cheque Payment": "Çek Ödemesi",
    "Promissory Note Collection": "Senet Tahsilatı",
    "Promissory Note Payment": "Senet Ödemesi",
    "NET CASH POSITION": "NET NAKİT POZİSYONU",
    "Collections less outstanding supplier payables": "Tahsilatlar eksi bekleyen tedarikçi borçları",
    "Create Manual Invoice": "Manuel Fatura Oluştur",
    "Refresh dashboard": "Paneli yenile",
    "Executive Overview": "Finansal Genel Bakış",
    "Consolidated financial indicators across all active shipments.": "Tüm aktif sevkiyatların konsolide finansal göstergeleri.",
    "Last 30 days": "Son 30 gün",
    "Last 3 months": "Son 3 ay",
    "Last 6 months": "Son 6 ay",
    "Last 12 months": "Son 12 ay",
    "Export": "Dışa Aktar",
    "Finance Jobs": "Finans İşleri",
    "Net Invoice Amount": "Net Fatura Tutarı",
    "Net Profit": "Net Kâr",
    "Receivables": "Alacaklar",
    "Cash Flow": "Nakit Akışı",
    "Total Cost": "Toplam Maliyet",
    "Payables": "Borçlar",
    "Open Finance Jobs": "Açık Finans İşleri",
    "High-Risk Exposure": "Yüksek Riskli Alacaklar",
    "Revenue / Expense Report Filters": "Gelir / Gider Rapor Filtreleri",
    "Select a date, company, geography, transport mode, return status, credit risk and report currency": "Tarih, şirket, coğrafya, taşıma modu, iade durumu, kredi riski ve rapor para birimini seçin",
    "Clear Filters": "Filtreleri Temizle",
    "Start Date": "Başlangıç Tarihi",
    "End Date": "Bitiş Tarihi",
    "Customer / Supplier": "Müşteri / Tedarikçi",
    "Select a company": "Şirket seçin",
    "Geographic Scope": "Coğrafi Kapsam",
    "All Geographic Scopes": "Tüm Coğrafi Kapsamlar",
    "Transport Mode": "Taşıma Modu",
    "All Transport Modes": "Tüm Taşıma Modları",
    "Currency": "Para Birimi",
    "Display Currency": "Görüntüleme Para Birimi",
    "Filters which records are listed": "Hangi kayıtların listeleneceğini filtreler",
    "Currency used for totals": "Toplamlarda kullanılan para birimi",
    "Totals are shown in this currency": "Toplamlar bu para biriminde gösterilir",
    "Invoice Origin": "Fatura Kaynağı",
    "All Origins": "Tüm Kaynaklar",
    "Return Status": "İade Durumu",
    "All Return Statuses": "Tüm İade Durumları",
    "Credit Risk": "Kredi Riski",
    "Collection Risk Monitor": "Tahsilat Risk Takibi",
    "Highest outstanding exposure among doubtful, bad debt and written-off invoices": "Şüpheli, değersiz ve kayıttan düşülmüş faturalardaki en yüksek açık riskler",
    "Manage Risks": "Riskleri Yönet",
    "No risk reason entered": "Risk açıklaması girilmemiş",
    "No doubtful, bad debt or written-off collection records match the selected filters.": "Seçili filtrelere uygun şüpheli, değersiz veya kayıttan düşülmüş tahsilat kaydı bulunamadı.",
    "Finance Action Center": "Finans Aksiyon Merkezi",
    "Items requiring immediate finance attention": "Finans ekibinin müdahale etmesi gereken kayıtlar",
    "Click a row to review": "İncelemek için satıra tıklayın",
    "Overdue receivables": "Vadesi geçmiş alacaklar",
    "Pending supplier approvals": "Bekleyen tedarikçi onayları",
    "Negative-margin jobs": "Negatif marjlı işler",
    "Missing exchange rates": "Eksik döviz kurları",
    "Review": "İncele",
    "90-Day Cash Flow Forecast": "90 Günlük Nakit Akışı Tahmini",
    "Expected collections and supplier payments in": "Beklenen tahsilat ve tedarikçi ödemeleri:",
    "Next 7 days": "Önümüzdeki 7 gün",
    "8–30 days": "8–30 gün",
    "31–60 days": "31–60 gün",
    "61–90 days": "61–90 gün",
    "In": "Giriş",
    "Out": "Çıkış",
    "Forecast net cash": "Tahmini net nakit",
    "Profitability Drill-Down": "Kârlılık Detayı",
    "Customer-level revenue, cost and margin": "Müşteri bazında gelir, maliyet ve marj",
    "Click a customer for job details": "İş detayları için müşteriye tıklayın",
    "View details": "Detayları Gör",
    "Transport Performance": "Taşıma Performansı",
    "Road, ocean and air shipment volume, revenue, cost and margin overview": "Karayolu, denizyolu ve havayolu iş hacmi, gelir, maliyet ve marj görünümü",
    "Top mode": "En yoğun mod",
    "Ocean": "Denizyolu",
    "Road": "Karayolu",
    "Air": "Havayolu",
    "Revenue by Transport Mode": "Taşıma Moduna Göre Gelir",
    "Financial contribution of ocean, road and air operations": "Denizyolu, karayolu ve havayolu operasyonlarının finansal katkısı",
    "Shipment Type Distribution": "Sevkiyat Tipi Dağılımı",
    "Most frequently used transport and service types": "En sık kullanılan taşıma ve servis tipleri",
    "Shipment type data not found": "Sevkiyat tipi verisi bulunamadı",
    "Add shipmentType, serviceType or transportType fields to finance jobs.": "Finans işlerine shipmentType, serviceType veya transportType alanlarını ekleyin.",
    "Financial Performance": "Finansal Performans",
    "Revenue, cost and collection trend": "Gelir, maliyet ve tahsilat eğilimi",
    "Finance Health": "Finans Sağlığı",
    "Liquidity, collection and risk adjusted score": "Likidite, tahsilat ve risk bazlı skor",
    "Health Score": "Sağlık Skoru",
    "out of 100": "100 üzerinden",
    "COLLECTION RATE": "TAHSİLAT ORANI",
    "PAYABLE COVER": "BORÇ KARŞILAMA",
    "Receivables Aging": "Alacak Yaşlandırması",
    "Outstanding customer balances by overdue period": "Vadesi geçen süreye göre açık müşteri bakiyeleri",
    "Current": "Güncel",
    "1–30 Days": "1–30 Gün",
    "31–60 Days": "31–60 Gün",
    "61+ Days": "61+ Gün",
    "Total Outstanding": "Toplam Açık Tutar",
    "Overdue exposure": "Vadesi geçmiş risk",
    "Top Customers": "En Büyük Müşteriler",
    "Revenue concentration by account": "Hesap bazında gelir yoğunluğu",
    "No customer revenue data available.": "Müşteri gelir verisi bulunamadı.",
    "Finance Operations": "Finans Operasyonları",
    "Frequently used finance workflows": "Sık kullanılan finans işlemleri",
    "Create Customer Invoice": "Müşteri Faturası Oluştur",
    "Generate a new shipment invoice": "Yeni bir sevkiyat faturası oluştur",
    "Record Collection": "Tahsilat Kaydet",
    "Register incoming customer payment": "Gelen müşteri ödemesini kaydet",
    "Add Supplier Cost": "Tedarikçi Maliyeti Ekle",
    "Book operational or supplier expense": "Operasyon veya tedarikçi gideri kaydet",
    "Upload Supplier Invoice": "Tedarikçi Faturası Yükle",
    "Attach invoice and supporting document": "Fatura ve destekleyici dokümanı ekle",
    "Bank Reconciliation": "Banka Mutabakatı",
    "Review unmatched finance movements.": "Eşleşmemiş finans hareketlerini inceleyin.",
    "Recent Finance Jobs": "Son Finans İşleri",
    "Latest net invoice, return, cost, profitability and collection movements": "Son net fatura, iade, maliyet, kârlılık ve tahsilat hareketleri",
    "View All Jobs": "Tüm İşleri Gör",
    "JOB / SHIPMENT": "İŞ / SEVKİYAT",
    "CUSTOMER": "MÜŞTERİ",
    "NET INVOICE": "NET FATURA",
    "RETURN STATUS": "İADE DURUMU",
    "COST": "MALİYET",
    "PROFITABILITY": "KÂRLILIK",
    "CREDIT RISK": "KREDİ RİSKİ",
    "COLLECTION": "TAHSİLAT",
    "FINANCE STATUS": "FİNANS DURUMU",
    "ACTIONS": "İŞLEMLER",
    "Supplier cost + buying rate": "Tedarikçi maliyeti + alış bedeli",
    "Pending": "Bekliyor",
    "Finance Open": "Finans Açık",
    "View latest return invoice": "Son iade faturasını görüntüle",
    "View finance detail": "Finans detayını görüntüle",
    "Edit invoice": "Faturayı düzenle",
    "View PDF": "PDF'yi görüntüle",
    "No Return": "İade Yok",
    "Return Draft": "İade Taslak",
    "Return Approved": "İade Onaylandı",
    "Partial Return": "Kısmi İade",
    "Full Return": "Tam İade",
    "Return Pending": "İade Bekliyor",
    "Return Cancelled": "İade İptal",
    "Finance Details": "Finans Detayları",
    "No matching records.": "Eşleşen kayıt bulunamadı.",
    "Close": "Kapat",
    "Finance Job ID not found!": "Finance Job ID bulunamadı!",
    "Shipment ID not found!": "Sevkiyat ID bulunamadı!",
    "PDF not found!": "PDF bulunamadı!",
    "Return invoice ID not found!": "İade faturası ID bulunamadı!",
    "No report data is available to export to Excel.": "Excel'e aktarılabilecek rapor verisi bulunamadı.",

    // =========================================================
    // FINANCE JOBS
    // =========================================================

    "CORPORATE FINANCE OPERATIONS":
        "KURUMSAL FİNANS OPERASYONLARI",

    "Manage shipment finance records, invoice lifecycle, profitability, collection status and operational exposure from one banking-grade workspace.":
        "Sevkiyat finans kayıtlarını, fatura yaşam döngüsünü, kârlılığı, tahsilat durumunu ve operasyonel riskleri tek bir kurumsal çalışma alanından yönetin.",

    "finance records":
        "finans kaydı",

    "FILTERED PORTFOLIO PROFIT":
        "FİLTRELENMİŞ PORTFÖY KÂRI",

    "across current filter result":
        "mevcut filtre sonucunda",

    "Refresh finance jobs":
        "Finans işlerini yenile",

    "Customer":
        "Müşteri",

    "Supplier":
        "Tedarikçi",

    "Filtered actual revenue":
        "Filtrelenmiş gerçekleşen gelir",

    "Filtered supplier cost":
        "Filtrelenmiş tedarikçi maliyeti",

    "Incomplete — exchange rate unavailable for some jobs":
        "Eksik — bazı işler için döviz kuru alınamadı",

    "Open Jobs":
        "Açık İşler",

    "Finance job records":
        "Finans iş kayıtları",

    "Supplier Waiting":
        "Tedarikçi Bekleyen",

    "Missing supplier invoice":
        "Eksik tedarikçi faturası",

    "Customer Waiting":
        "Müşteri Bekleyen",

    "high-risk records":
        "yüksek riskli kayıt",

    "OPERATIONS":
        "OPERASYONLARI",

    "Finance jobs":
        "Finans işleri",

    "share":
        "pay",

    "Revenue contribution of Ocean, Road and Air operations":
        "Denizyolu, karayolu ve havayolu operasyonlarının gelir katkısı",

    "Shipment Type Mix":
        "Sevkiyat Tipi Dağılımı",

    "Most frequently used shipment services":
        "En sık kullanılan sevkiyat servisleri",

    "No shipment type data available.":
        "Sevkiyat tipi verisi bulunamadı.",

    "Finance Job Filters":
        "Finans İş Filtreleri",

    "Search and segment finance operations by shipment, customer and status.":
        "Finans operasyonlarını sevkiyat, müşteri ve duruma göre arayın ve filtreleyin.",

    "Refresh":
        "Yenile",

    "Reset":
        "Sıfırla",

    "Export CSV":
        "CSV Dışa Aktar",

    "Dashboard":
        "Panel",

    "Search":
        "Ara",

    "Shipment, customer, email...":
        "Sevkiyat, müşteri, e-posta...",

    "All Finance Statuses":
        "Tüm Finans Durumları",

    "Collection Status":
        "Tahsilat Durumu",

    "All Collection Statuses":
        "Tüm Tahsilat Durumları",

    "Customer Invoice":
        "Müşteri Faturası",

    "All Invoice Statuses":
        "Tüm Fatura Durumları",

    "CUSTOMER INVOICES":
        "MÜŞTERİ FATURALARI",

    "REVENUE":
        "GELİR",

    "CUSTOMER INVOICE":
        "MÜŞTERİ FATURASI",

    "Customer Billing":
        "Müşteri Faturalaması",

    "Supplier Cost + Buying Rate":
        "Tedarikçi Maliyeti + Alış Bedeli",

    "Rate unavailable":
        "Kur bilgisi yok",

    "Missing exchange rate":
        "Eksik döviz kuru",

    "Open finance job detail":
        "Finans iş detayını aç",

    "Select an invoice from finance job detail":
        "Finans iş detayından bir fatura seç",

    "Edit customer invoice":
        "Müşteri faturasını düzenle",

    "Open latest return invoice":
        "Son iade faturasını aç",

    "No return invoice":
        "İade faturası yok",

    "View net selling rate PDF":
        "Net satış tutarı PDF'ini görüntüle",

    "customer invoice":
        "müşteri faturası",

    "customer invoices":
        "müşteri faturası",

    "Draft":
        "Taslak",

    "Sales":
        "Satış",

    "No return activity":
        "İade hareketi yok",

    "returned":
        "iade edildi",

    "reserved":
        "rezerve",

    "Not Returned":
        "İade Edilmedi",

    "Return Issued":
        "İade Kesildi",

    "Partially Returned":
        "Kısmen İade Edildi",

    "Fully Returned":
        "Tamamen İade Edildi",

    "Finance jobs could not be loaded.":
        "Finans işleri yüklenemedi.",

    "No return invoice was found for this finance job.":
        "Bu finans işi için iade faturası bulunamadı.",

    "Invoice PDF could not be created.":
        "Fatura PDF'i oluşturulamadı.",

    "Showing":
        "Gösterilen",

    "of":
        "toplam",

    "Invoice letterhead could not be loaded.": "Fatura antet görseli yüklenemedi.",
    "Draft invoice PDF could not be generated.": "Taslak fatura PDF'i oluşturulamadı.",
    "Customer invoices could not be loaded.": "Müşteri faturaları yüklenemedi.",
    "Return information could not be loaded.": "İade bilgileri yüklenemedi.",
    "Customer invoice ID not found!": "Müşteri faturası ID'si bulunamadı!",
    "Shipment ID not found for this finance job!": "Bu finans işi için sevkiyat ID'si bulunamadı!",
    "Loading finance job details...": "Finans iş detayları yükleniyor...",
    "Finance job not found": "Finans işi bulunamadı",
    "The requested finance record may have been removed or is not accessible.": "İstenen finans kaydı silinmiş veya erişilemiyor olabilir.",
    "Back to Finance Jobs": "Finans İşlerine Dön",
    "FINANCE JOB CONTROL CENTER": "FİNANS İŞ KONTROL MERKEZİ",
    "NET JOB PROFIT": "NET İŞ KÂRI",
    "Edit Manual Invoice": "Manuel Faturayı Düzenle",
    "Create Invoice": "Fatura Oluştur",
    "View job draft PDF": "İş taslak PDF'ini görüntüle",
    "Actual Revenue": "Gerçekleşen Gelir",
    "Actual Revenue (incl. VAT)": "Gerçekleşen Gelir (KDV dahil)",
    "Incl. VAT": "KDV dahil",
    "Foreign Invoice PDF": "Yurtdışı Fatura PDF'i",
    "Attach the foreign invoice as a PDF and e-mail it to accounting to be processed.": "Yurtdışı faturayı PDF olarak ekleyin ve işlenmesi için muhasebeye e-postayla gönderin.",
    "Choose PDF": "PDF seç",
    "Replace PDF": "PDF'i değiştir",
    "E-mail the PDF to accounting for processing when saving": "Kaydederken PDF'i işlenmesi için muhasebeye e-postayla gönder",
    "E-mailed to": "Şu adreslere gönderildi:",
    "Not e-mailed yet": "Henüz e-postayla gönderilmedi",
    "Send to accounting": "Muhasebeye gönder",
    "Send again": "Tekrar gönder",
    "Remove the attached PDF?": "Ekli PDF kaldırılsın mı?",
    "The PDF could not be uploaded.": "PDF yüklenemedi.",
    "Only PDF files can be uploaded.": "Yalnızca PDF dosyaları yüklenebilir.",
    "The PDF is larger than": "PDF şu boyuttan büyük:",
    "PDF not found.": "PDF bulunamadı.",
    "But the PDF step failed": "Ancak PDF adımı başarısız oldu",
    "Open the invoice and try again.": "Faturayı açıp tekrar deneyin.",
    "PDF e-mailed to": "PDF şu adreslere e-postalandı:",
    "No number yet": "Henüz numara yok",
    "Not linkable": "Bağlanamaz",
    "Rejected invoices cannot be linked to a job.": "Reddedilen faturalar bir işe bağlanamaz.",
    "rejected invoices excluded": "reddedilen fatura hariç",
    "Excluding rejected invoices": "Reddedilen faturalar hariç",
    "Supplier cost line could not be saved.": "Tedarikçi maliyet satırı kaydedilemedi.",
    "VAT Exemption Reason Code (GİB)": "KDV İstisna Sebep Kodu (GİB)",
    "Applies to the 0% VAT lines. This invoice is sent to EDM as an exempt (İstisna) invoice. Default: 311 - international transport; technology: 223. Use 20% VAT for regular taxable sales.": "%0 KDV'li satırlar için geçerlidir. Bu fatura EDM'e istisna faturası olarak gider. Varsayılan: 311 - uluslararası taşımacılık; teknoloji: 223. Normal satışlarda %20 KDV kullanın.",
    "Closed": "Kapandı",
    "Created (not sent yet)": "Oluşturuldu (henüz gönderilmedi)",
    "Revenue (incl. VAT)": "Gelir (KDV dahil)",
    "Actual Cost": "Gerçekleşen Maliyet",
    "Actual Profit": "Gerçekleşen Kâr",
    "Expected": "Beklenen",
    "Missing": "Eksik",
    "exchange rate": "döviz kuru",
    "Operational Cost": "Operasyonel Maliyet",
    "Buying Rate": "Alış Bedeli",
    "Receivable": "Alacaklar",
    "Open Payable": "Açık Borç",
    "Cash Position": "Nakit Pozisyonu",
    "Freight and operating expenses": "Navlun ve operasyon giderleri",
    "Additional purchase cost": "Ek satın alma maliyeti",
    "Outstanding customer balance": "Açık müşteri bakiyesi",
    "Unpaid supplier exposure": "Ödenmemiş tedarikçi yükümlülüğü",
    "Collections less supplier payments": "Tahsilatlar eksi tedarikçi ödemeleri",
    "Profitability and liquidity score": "Kârlılık ve likidite skoru",
    "Provision": "Karşılık",
    "Managed in Collections": "Tahsilatlar bölümünde yönetiliyor",
    "Expected and actual revenue, cost and profit comparison.": "Beklenen ve gerçekleşen gelir, maliyet ve kâr karşılaştırması.",
    "Liquidity Overview": "Likidite Genel Görünümü",
    "Cash conversion and open exposure for this finance job.": "Bu finans işi için nakit dönüşümü ve açık yükümlülük görünümü.",
    "Finance Workspace": "Finans Çalışma Alanı",
    "Manage billing, supplier exposure, documents and profitability from one operational workspace.": "Faturalama, tedarikçi yükümlülükleri, belgeler ve kârlılığı tek bir operasyonel çalışma alanından yönetin.",
    "Section": "Bölüm",
    "Overview": "Genel Bakış",
    "Core job information and finance workflow status.": "Temel iş bilgileri ve finans iş akışı durumu.",
    "Customer Invoices": "Müşteri Faturaları",
    "Billing, collection, balance and return invoice control.": "Faturalama, tahsilat, bakiye ve iade faturası kontrolü.",
    "Supplier Costs": "Tedarikçi Maliyetleri",
    "Expected and actual operating cost variance tracking.": "Beklenen ve gerçekleşen operasyon maliyeti fark takibi.",
    "Supplier Invoices": "Tedarikçi Faturaları",
    "Supplier invoice approval, due date and payment workflow.": "Tedarikçi faturası onayı, vade tarihi ve ödeme iş akışı.",
    "Documents": "Belgeler",
    "Finance and shipment document archive for this job.": "Bu işe ait finans ve sevkiyat belge arşivi.",
    "Profitability": "Kârlılık",
    "Revenue, cost, profit, margin and variance analysis.": "Gelir, maliyet, kâr, marj ve fark analizi.",
    "Activity": "Aktivite",
    "Audit trail of finance actions and workflow events.": "Finans işlemleri ve iş akışı olaylarının denetim kaydı.",
    "record": "kayıt",
    "Job Information": "İş Bilgileri",
    "Core shipment and commercial details.": "Temel sevkiyat ve ticari detaylar.",
    "Finance Status": "Finans Durumu",
    "Current invoice, payment and closing position.": "Mevcut fatura, ödeme ve kapanış durumu.",
    "Shipper": "Gönderici",
    "Consignee": "Alıcı",
    "Origin": "Çıkış",
    "Destination": "Varış",
    "Incoterm": "Incoterm",
    "Supplier Invoice": "Tedarikçi Faturası",
    "Supplier Payment": "Tedarikçi Ödemesi",
    "Closing": "Kapanış",
    "Open Collections": "Tahsilatları Aç",
    "Billing, payment and balance records for this job.": "Bu işe ait faturalama, ödeme ve bakiye kayıtları.",
    "This invoice has been fully returned.": "Bu fatura tamamen iade edilmiştir.",
    "Create a full or partial return invoice.": "Tam veya kısmi iade faturası oluştur.",
    "Create Return Invoice": "İade Faturası Oluştur",
    "Loading...": "Yükleniyor...",
    "ORIGINAL AMOUNT": "ORİJİNAL TUTAR",
    "RETURNABLE AMOUNT": "İADE EDİLEBİLİR TUTAR",
    "No customer invoice found.": "Müşteri faturası bulunamadı.",
    "Return Invoice History": "İade Faturası Geçmişi",
    "Full and partial returns linked to the original invoice.": "Orijinal faturaya bağlı tam ve kısmi iadeler.",
    "No return invoice found.": "İade faturası bulunamadı.",
    "Expected cost, actual invoice and variance control.": "Beklenen maliyet, gerçekleşen fatura ve fark kontrolü.",
    "Add Cost Line": "Maliyet Satırı Ekle",
    "No supplier cost line found.": "Tedarikçi maliyet satırı bulunamadı.",
    "Supplier invoice approval and payment status.": "Tedarikçi faturası onay ve ödeme durumu.",
    "Upload Invoice": "Fatura Yükle",
    "No supplier invoice found.": "Tedarikçi faturası bulunamadı.",
    "Finance and shipment documents associated with this job.": "Bu işle ilişkili finans ve sevkiyat belgeleri.",
    "Upload Document": "Belge Yükle",
    "No document found.": "Belge bulunamadı.",
    "Revenue Variance": "Gelir Farkı",
    "Cost Variance": "Maliyet Farkı",
    "Profit Variance": "Kâr Farkı",
    "Actual minus expected": "Gerçekleşen eksi beklenen",
    "Margin Performance": "Marj Performansı",
    "Activity Log": "Aktivite Kaydı",
    "Financial actions and workflow history.": "Finansal işlemler ve iş akışı geçmişi.",
    "No activity found.": "Aktivite bulunamadı.",
    "EXECUTIVE FINANCE SUMMARY": "YÖNETİCİ FİNANS ÖZETİ",
    "This finance job is in a strong position.": "Bu finans işi güçlü bir konumdadır.",
    "This finance job requires controlled follow-up.": "Bu finans işi kontrollü takip gerektiriyor.",
    "This finance job requires immediate financial attention.": "Bu finans işi acil finansal müdahale gerektiriyor.",
    "Revenue is": "Gelir",
    "above": "beklentinin üzerinde",
    "below": "beklentinin altında",
    "expected by": "oranında",
    "Collection performance is": "Tahsilat performansı",
    "while open receivables stand at": "açık alacaklar",
    "and supplier exposure at": "ve tedarikçi yükümlülüğü",
    "Total cost is": "Toplam maliyet",
    "including": "bunun içinde",
    "buying rate": "alış bedeli bulunmaktadır",
    "FINANCE HEALTH SCORE": "FİNANS SAĞLIK SKORU",
    "vs expected": "beklenene göre",
    "INVOICE NO": "FATURA NO",
    "INVOICE DATE": "FATURA TARİHİ",
    "DUE DATE": "VADE TARİHİ",
    "AMOUNT": "TUTAR",
    "PAID": "ÖDENEN",
    "BALANCE": "BAKİYE",
    "STATUS": "DURUM",
    "View customer invoice": "Müşteri faturasını görüntüle",
    "Show return information": "İade bilgilerini göster",
    "Returns": "İadeler",
    "SUPPLIER": "TEDARİKÇİ",
    "SERVICE": "HİZMET",
    "EXPECTED": "BEKLENEN",
    "ACTUAL": "GERÇEKLEŞEN",
    "VARIANCE": "FARK",
    "TOLERANCE": "TOLERANS",
    "APPROVAL": "ONAY",
    "PAYMENT": "ÖDEME",
    "DATE": "TARİH",
    "DOCUMENT": "BELGE",
    "TYPE": "TÜR",
    "UPLOADED AT": "YÜKLENME TARİHİ",
    "ACTION": "İŞLEM",
    "View": "Görüntüle",
    "No File": "Dosya Yok",
    "Document": "Belge",
    "RETURN NO": "İADE NO",

    "CORPORATE RECEIVABLES CENTER": "KURUMSAL ALACAK YÖNETİM MERKEZİ",
    "Manage invoices, return invoices, delivery, maturity dates, collections, overdue exposure and customer balances from one banking-grade workspace.": "Faturaları, iade faturalarını, gönderim durumunu, vade tarihlerini, tahsilatları, vadesi geçmiş riskleri ve müşteri bakiyelerini tek bir kurumsal çalışma alanından yönetin.",
    "document records": "belge kaydı",
    "OUTSTANDING RECEIVABLES": "AÇIK ALACAKLAR",
    "Collection rate": "Tahsilat oranı",
    "across filtered invoices": "filtrelenmiş faturalar genelinde",
    "All Customers / Suppliers": "Tüm Müşteriler / Tedarikçiler",
    "All Currencies": "Tüm Para Birimleri",
    "Document Type": "Belge Türü",
    "All Document Types": "Tüm Belge Türleri",
    "Invoice": "Fatura",
    "Return Invoice": "İade Faturası",
    "Invoices and return invoices": "Faturalar ve iade faturaları",
    "Invoice Total": "Fatura Toplamı",
    "Total customer billing": "Toplam müşteri faturalaması",
    "Outstanding": "Açık Bakiye",
    "Doubtful, bad debt and written-off balance": "Şüpheli, değersiz ve kayıttan düşülmüş alacak bakiyesi",
    "draft invoices": "taslak fatura",
    "Operational cost + buying rate": "Operasyonel maliyet + alış bedeli",
    "Included purchase cost": "Dahil edilen satın alma maliyeti",
    "Gross Profit": "Brüt Kâr",
    "vs previous period": "önceki döneme göre",
    "INVOICES": "FATURALAR",
    "Customer invoices": "Müşteri faturaları",
    "Billed": "Faturalanan",
    "Gross profit": "Brüt kâr",
    "Invoice Value by Transport Mode": "Taşıma Moduna Göre Fatura Değeri",
    "Customer billing and outstanding receivables across Ocean, Road and Air": "Denizyolu, karayolu ve havayolu bazında müşteri faturalaması ve açık alacaklar",
    "Most frequently invoiced logistics services": "En sık faturalanan lojistik hizmetleri",
    "No shipment type information is available.": "Sevkiyat tipi bilgisi bulunamadı.",
    "Invoice Filters": "Fatura Filtreleri",
    "Search and segment invoices and return invoices by number, customer, document type and status.": "Faturaları ve iade faturalarını numara, müşteri, belge türü ve duruma göre arayın ve filtreleyin.",
    "Shipment, invoice, customer...": "Sevkiyat, fatura, müşteri...",
    "Invoice Status": "Fatura Durumu",
    "Due Status": "Vade Durumu",
    "All Due Statuses": "Tüm Vade Durumları",
    "Not Due": "Vadesi Gelmedi",
    "No Due Date": "Vade Tarihi Yok",
    "invoice documents": "fatura belgesi",
    "SHIPMENT": "SEVKİYAT",
    "INVOICE": "FATURA",
    "DOCUMENT TYPE": "BELGE TÜRÜ",
    "ORIGIN": "KAYNAK",
    "INVOICE STATUS": "FATURA DURUMU",
    "PAYMENT TERM": "ÖDEME VADESİ",
    "Original": "Orijinal",
    "No email": "E-posta yok",
    "Not Applicable": "Uygulanamaz",
    "days overdue": "gün gecikmiş",
    "Within payment term": "Ödeme vadesi içinde",
    "Receivable adjustment": "Alacak düzeltmesi",
    "Paid": "Ödenen",
    "Balance": "Bakiye",
    "Stored cost": "Kayıtlı maliyet",
    "margin": "marj",
    "document": "belge",
    "Open Collections to manage this risk": "Bu riski yönetmek için Tahsilatlar ekranını açın",
    "View Invoice PDF": "Fatura PDF'ini Görüntüle",
    "No PDF": "PDF Yok",
    "View Invoice": "Faturayı Görüntüle",
    "Open Original Invoice": "Orijinal Faturayı Aç",
    "Open Latest Return Invoice": "Son İade Faturasını Aç",
    "Mark as Sent": "Gönderildi Olarak İşaretle",
    "Add collection": "Tahsilat Ekle",
    "Refresh Invoices": "Faturaları Yenile",
    "Return Invoice ID not found!": "İade faturası ID'si bulunamadı!",
    "Original Invoice ID not found!": "Orijinal fatura ID'si bulunamadı!",
    "No linked return invoice was found.": "Bağlı iade faturası bulunamadı.",
    "Manual Invoice ID not found!": "Manuel fatura ID'si bulunamadı!",
    "Invoice ID not found!": "Fatura ID'si bulunamadı!",
    "Invoice could not be marked as sent. Backend PATCH /invoice/:id should be checked.": "Fatura gönderildi olarak işaretlenemedi. Backend PATCH /invoice/:id kontrol edilmeli.",
    "CORPORATE SUPPLIER INVOICE CENTER": "KURUMSAL TEDARİKÇİ FATURA MERKEZİ",
    "Manage supplier invoices, master cost relations, duplicate controls, approvals, payment statuses and maturity dates.": "Tedarikçi faturalarını, ana maliyet ilişkilerini, mükerrer kontrollerini, onayları, ödeme durumlarını ve vade tarihlerini yönetin.",
    "supplier invoice records": "tedarikçi fatura kaydı",
    "NET PAYABLE": "NET ÖDENECEK",
    "Additional supplier cost": "Ek tedarikçi maliyeti",
    "Refresh supplier invoices": "Tedarikçi faturalarını yenile",
    "All Documents": "Tüm Belgeler",
    "Return Invoices": "İade Faturaları",
    "Invoices": "Faturalar",
    "return documents in filtered view": "filtrelenmiş görünümde iade belgesi",
    "Total Amount": "Toplam Tutar",
    "Issued returns": "Kesilen iadeler",
    "Net Payable": "Net Ödenecek",
    "Supplier exposure after issued returns": "Kesilen iadeler sonrası tedarikçi yükümlülüğü",
    "Approved": "Onaylandı",
    "pending approvals": "bekleyen onay",
    "Purchase cost linked to jobs": "İşlere bağlı satın alma maliyeti",
    "Master Cost": "Ana Maliyet",
    "Operational cost plus buying rate": "Operasyonel maliyet artı alış bedeli",
    "Additional Cost": "Ek Maliyet",
    "invoices already included": "fatura zaten dahil",
    "Unpaid Payables": "Ödenmemiş Borçlar",
    "SUPPLIER INVOICES": "TEDARİKÇİ FATURALARI",
    "of filtered invoices": "filtrelenmiş faturaların",
    "Unpaid": "Ödenmemiş",
    "Approval": "Onay",
    "approved": "onaylandı",
    "Payables by Transport Mode": "Taşıma Moduna Göre Borçlar",
    "Supplier invoice exposure across Ocean, Road and Air": "Denizyolu, karayolu ve havayolu bazında tedarikçi fatura yükümlülüğü",
    "Supplier invoice distribution by logistics service": "Lojistik hizmetine göre tedarikçi fatura dağılımı",
    "No shipment type data": "Sevkiyat tipi verisi yok",
    "Supplier Invoice Filters": "Tedarikçi Fatura Filtreleri",
    "Search supplier invoices by job, supplier, approval, payment and duplicate status.": "Tedarikçi faturalarını iş, tedarikçi, onay, ödeme ve mükerrer durumuna göre arayın.",
    "Shipment, supplier, invoice...": "Sevkiyat, tedarikçi, fatura...",
    "All Approvals": "Tüm Onaylar",
    "All Payments": "Tüm Ödemeler",
    "Duplicate": "Mükerrer",
    "All Duplicate Statuses": "Tüm Mükerrer Durumları",
    "supplier invoice documents": "tedarikçi fatura belgesi",
    "Additional": "Ek",
    "Net": "Net",
    "DATES": "TARİHLER",
    "COST RELATION": "MALİYET İLİŞKİSİ",
    "DUPLICATE": "MÜKERRER",
    "FILE": "DOSYA",
    "Matched jobs": "Eşleşen işler",
    "Tax No": "Vergi No",
    "Return": "İade",
    "Due": "Vade",
    "VAT": "KDV",
    "Impact": "Etki",
    "Returned": "İade Edilen",
    "Return Adjustment": "İade Düzeltmesi",
    "Included": "Dahil",
    "Already in master cost": "Ana maliyete zaten dahil",
    "return document": "iade belgesi",
    "return documents": "iade belgesi",
    "View supplier invoice": "Tedarikçi faturasını görüntüle",
    "View return invoice": "İade faturasını görüntüle",
    "Finance detail": "Finans detayı",
    "Open original invoice": "Orijinal faturayı aç",
    "Already approved": "Zaten onaylandı",
    "Approve invoice": "Faturayı onayla",
    "No payable balance after returns": "İadeler sonrası ödenecek bakiye yok",
    "Already paid": "Zaten ödendi",
    "Mark as paid": "Ödendi olarak işaretle",
    "Register supplier invoice, finance job relation and master cost status.": "Tedarikçi faturasını, finans işi ilişkisini ve ana maliyet durumunu kaydedin.",
    "Finance Job ID": "Finans İş ID",
    "Shipment ID": "Sevkiyat ID",
    "Shipment / Job No": "Sevkiyat / İş No",
    "Supplier Name": "Tedarikçi Adı",
    "Supplier Tax No": "Tedarikçi Vergi No",
    "Invoice No": "Fatura No",
    "Invoice Date": "Fatura Tarihi",
    "VAT Amount": "KDV Tutarı",
    "Approval Status": "Onay Durumu",
    "Payment Status": "Ödeme Durumu",
    "Master Cost Relation": "Ana Maliyet İlişkisi",
    "Additional Supplier Cost": "Ek Tedarikçi Maliyeti",
    "Already Included in Master Cost": "Ana Maliyete Zaten Dahil",
    "PDF / XML URL": "PDF / XML URL",
    "Save Supplier Invoice": "Tedarikçi Faturasını Kaydet",
    "Rejected": "Reddedildi",
    "Finance Job ID not found. Supplier invoice must be linked with financeJobId.": "Finance Job ID bulunamadı. Tedarikçi faturası financeJobId ile ilişkilendirilmelidir.",
    "Document not found!": "Belge bulunamadı!",
    "Supplier name is required.": "Tedarikçi adı zorunludur.",
    "Invoice no is required.": "Fatura numarası zorunludur.",
    "Total amount is required.": "Toplam tutar zorunludur.",
    "Supplier invoice could not be saved.": "Tedarikçi faturası kaydedilemedi.",
    "Approve could not be saved.": "Onay kaydedilemedi.",
    "This supplier invoice has no payable balance after returns.": "Bu tedarikçi faturasının iadeler sonrası ödenecek bakiyesi bulunmuyor.",
    "Payment status could not be saved.": "Ödeme durumu kaydedilemedi.",
    "MANUAL FINANCE OPERATIONS": "MANUEL FİNANS OPERASYONLARI",
    "Create a sales or purchase invoice without a TMS shipment.": "TMS sevkiyatı olmadan satış veya alış faturası oluşturun.",
    "Sales Invoice": "Satış Faturası",
    "Purchase Invoice": "Alış Faturası",
    "Invoice Information": "Fatura Bilgileri",
    "General information and invoice party details": "Genel bilgiler ve fatura tarafı detayları",
    "Invoice Type": "Fatura Türü",
    "Generated automatically": "Otomatik oluşturulur",
    "Selected Account": "Seçili Hesap",
    "Search Customer / Service Provider / Global Agent": "Müşteri / Tedarikçi / Global Acente Ara",
    "Type to search or create an account": "Hesap aramak veya oluşturmak için yazın",
    "+ New Account": "+ Yeni Hesap",
    "Service Provider": "Tedarikçi",
    "Global Agent": "Global Acente",
    "Select supplier": "Tedarikçi seçin",
    "Email": "E-posta",
    "Exchange Rate": "Döviz Kuru",
    "Selling Currency": "Satış Para Birimi",
    "Cost Currency": "Maliyet Para Birimi",
    "Expense Center": "Gider Merkezi",
    "Select Expense Center": "Gider Merkezi Seçin",
    "GENERAL EXPENSES": "GENEL GİDERLER",
    "OCEAN OPERATIONS": "DENİZYOLU OPERASYONLARI",
    "ROAD OPERATIONS": "KARAYOLU OPERASYONLARI",
    "AIR OPERATIONS": "HAVAYOLU OPERASYONLARI",
    "WAREHOUSING": "DEPOLAMA",
    "CUSTOMS OPERATIONS": "GÜMRÜK OPERASYONLARI",
    "ADMINISTRATIVE EXPENSES": "İDARİ GİDERLER",
    "Branch": "Şube",
    "Operation": "Operasyon",
    "Select Operation": "Operasyon Seçin",
    "GENERAL": "GENEL",
    "OCEAN": "DENİZYOLU",
    "ROAD": "KARAYOLU",
    "AIR": "HAVAYOLU",
    "CUSTOMS": "GÜMRÜK",
    "Sales Representative": "Satış Temsilcisi",
    "Select sales representative": "Satış temsilcisi seçin",
    "Invoice Address": "Fatura Adresi",
    "Notes": "Notlar",
    "Invoice Line Items": "Fatura Kalemleri",
    "Total cost remains internal and is not displayed on the customer PDF.": "Toplam maliyet dahili olarak tutulur ve müşteri PDF'inde gösterilmez.",
    "Add Invoice Item": "Fatura Kalemi Ekle",
    "Item Code": "Kalem Kodu",
    "Invoice Item": "Fatura Kalemi",
    "Select Invoice Item": "Fatura Kalemi Seçin",
    "Freight Charge": "Navlun Ücreti",
    "Pickup Charge": "Alım Ücreti",
    "Delivery Charge": "Teslimat Ücreti",
    "Customs Clearance": "Gümrükleme",
    "Handling Charge": "Elleçleme Ücreti",
    "Documentation Fee": "Dokümantasyon Ücreti",
    "Storage Charge": "Depolama Ücreti",
    "Demurrage": "Demuraj",
    "Detention": "Detention",
    "Insurance": "Sigorta",
    "Other Service": "Diğer Hizmet",
    "Description": "Açıklama",
    "Qty": "Miktar",
    "Unit Price": "Birim Fiyat",
    "Sales Curr.": "Satış PB",
    "Cost Curr.": "Maliyet PB",
    "Duplicate item": "Kalemi çoğalt",
    "Delete item": "Kalemi sil",
    "Internal Cost": "Dahili Maliyet",
    "Additional Information": "Ek Bilgiler",
    "Discount Amount": "İndirim Tutarı",
    "Invoice Summary": "Fatura Özeti",
    "Subtotal": "Ara Toplam",
    "VAT Total": "Toplam KDV",
    "Discount": "İndirim",
    "Internal cost": "Dahili maliyet",
    "This value will not appear on the PDF.": "Bu değer PDF üzerinde gösterilmeyecektir.",
    "Preview": "Önizleme",
    "Save Draft": "Taslağı Kaydet",
    "Update and Approve": "Güncelle ve Onayla",
    "Save and Approve": "Kaydet ve Onayla",
    "Create Customer": "Müşteri Oluştur",
    "Invoice Preview": "Fatura Önizleme",
    "Total Cost is intentionally hidden from the preview.": "Toplam Maliyet önizlemede özellikle gizlenmiştir.",
    "Item": "Kalem",
    "Quantity": "Miktar",
    "Total": "Toplam",
    "Confirm Invoice": "Faturayı Onayla",
    "Customer is required.": "Müşteri zorunludur.",
    "Supplier is required.": "Tedarikçi zorunludur.",
    "Invoice date is required.": "Fatura tarihi zorunludur.",
    "At least one invoice item is required.": "En az bir fatura kalemi gereklidir.",
    "Every invoice item must have a name and quantity.": "Her fatura kaleminin adı ve miktarı olmalıdır.",
    "Invoice total must be greater than zero.": "Fatura toplamı sıfırdan büyük olmalıdır.",
    "Invoice saved and approved successfully.": "Fatura başarıyla kaydedildi ve onaylandı.",
    "Invoice draft saved successfully.": "Fatura taslağı başarıyla kaydedildi.",
    "Customers and suppliers could not be loaded.": "Müşteriler ve tedarikçiler yüklenemedi.",
    "Manual invoice could not be found.": "Manuel fatura bulunamadı.",
    "Manual invoice could not be loaded.": "Manuel fatura yüklenemedi.",
    "Manual invoice could not be saved.": "Manuel fatura kaydedilemedi.",
    "CORPORATE RECEIVABLES CONTROL": "KURUMSAL ALACAK KONTROL MERKEZİ",
    "Receivables Management": "Alacak Yönetimi",
    "Manage accounts receivable, aging, customer risk, sales returns, promise-to-pay commitments and collection actions from one banking-grade workspace.": "Alacak hesaplarını, yaşlandırmayı, müşteri riskini, satış iadelerini, ödeme taahhütlerini ve tahsilat aksiyonlarını tek bir kurumsal çalışma alanından yönetin.",
    "open receivables": "açık alacak",
    "days": "gün",
    "Collections": "Tahsilatlar",
    "Refresh receivables": "Alacakları yenile",
    "Open AR": "Açık Alacak",
    "Receivable records": "Alacak kayıtları",
    "Past due exposure": "Vadesi geçmiş risk",
    "Collection Rate": "Tahsilat Oranı",
    "Paid versus invoiced": "Ödenen / faturalanan oranı",
    "DSO": "DSO",
    "Weighted overdue days": "Ağırlıklı gecikme günü",
    "Critical Risk": "Kritik Risk",
    "Risk D / E customers": "D / E riskli müşteriler",
    "Issued Returns": "Kesilen İadeler",
    "Finalized sales returns": "Kesinleşmiş satış iadeleri",
    "Customer Credit": "Müşteri Alacak Bakiyesi",
    "Collected above net invoice": "Net faturanın üzerinde tahsil edilen",
    "Purchase cost included in total": "Toplama dahil satın alma maliyeti",
    "collected": "tahsil edildi",
    "Critical risk": "Kritik risk",
    "Receivables by Transport Mode": "Taşıma Moduna Göre Alacaklar",
    "Outstanding and overdue exposure across Ocean, Road and Air operations.": "Denizyolu, karayolu ve havayolu operasyonlarındaki açık ve vadesi geçmiş alacaklar.",
    "Open receivables grouped by shipment and service type.": "Açık alacakların sevkiyat ve servis tipine göre dağılımı.",
    "Aging Distribution": "Yaşlandırma Dağılımı",
    "Outstanding customer balances by maturity bucket.": "Açık müşteri bakiyelerinin vade aralığına göre dağılımı.",
    "Receivable Filters": "Alacak Filtreleri",
    "Search and segment receivables by customer, collection status, return status, aging and risk.": "Alacakları müşteri, tahsilat durumu, iade durumu, yaşlandırma ve riske göre arayın ve filtreleyin.",
    "Aging Bucket": "Yaşlandırma Aralığı",
    "All Aging Buckets": "Tüm Yaşlandırma Aralıkları",
    "0-30 Days": "0-30 Gün",
    "31-60 Days": "31-60 Gün",
    "61-90 Days": "61-90 Gün",
    "90+ Days": "90+ Gün",
    "Risk Score": "Risk Skoru",
    "All Risk Scores": "Tüm Risk Skorları",
    "Risk": "Risk",
    "receivable records": "alacak kaydı",
    "CUSTOMER / INVOICE": "MÜŞTERİ / FATURA",
    "AMOUNTS": "TUTARLAR",
    "DUE / AGING": "VADE / YAŞLANDIRMA",
    "RISK": "RİSK",
    "FOLLOW-UP": "TAKİP",
    "Promise": "Taahhüt",
    "Next": "Sonraki",
    "View invoice": "Faturayı görüntüle",
    "Send reminder": "Hatırlatma gönder",
    "Collection note": "Tahsilat notu",
    "Collection Follow-up": "Tahsilat Takibi",
    "Register promise-to-pay and next collection action.": "Ödeme taahhüdünü ve sonraki tahsilat aksiyonunu kaydedin.",
    "Promise To Pay": "Ödeme Taahhüdü",
    "Next Follow-up": "Sonraki Takip",
    "Collection Note": "Tahsilat Notu",
    "Save Follow-up": "Takibi Kaydet",
    "Customer email not found.": "Müşteri e-postası bulunamadı.",
    "Invoice ID not found.": "Fatura ID'si bulunamadı.",
    "Collection note could not be saved. Backend PATCH /invoice/:id should be checked.": "Tahsilat notu kaydedilemedi. Backend PATCH /invoice/:id kontrol edilmeli.",
    "CORPORATE COLLECTIONS CENTER": "KURUMSAL TAHSİLAT MERKEZİ",
    "Manage incoming customer payments, bank references, payment methods, matching status and invoice balances from one banking-grade workspace.": "Gelen müşteri ödemelerini, banka referanslarını, ödeme yöntemlerini, eşleştirme durumunu ve fatura bakiyelerini tek bir kurumsal çalışma alanından yönetin.",
    "collection records": "tahsilat kaydı",
    "TOTAL COLLECTED": "TOPLAM TAHSİLAT",
    "Match rate": "Eşleşme oranı",
    "Select an invoice below": "Aşağıdan bir fatura seçin",
    "Refresh collections": "Tahsilatları yenile",
    "Risk Status": "Risk Durumu",
    "All Risk Statuses": "Tüm Risk Durumları",
    "Overdue Range": "Gecikme Aralığı",
    "All Due Dates": "Tüm Vade Tarihleri",
    "1-30 Days": "1-30 Gün",
    "Filtered payment records": "Filtrelenmiş ödeme kayıtları",
    "Total incoming payments": "Toplam gelen ödemeler",
    "Net collectible balance after returns": "İadeler sonrası net tahsil edilebilir bakiye",
    "Issued returns reducing receivables": "Alacakları azaltan kesilmiş iadeler",
    "Matched": "Eşleşen",
    "Failed": "Başarısız",
    "Failed or cancelled records": "Başarısız veya iptal edilmiş kayıtlar",
    "Overdue Receivables": "Vadesi Geçmiş Alacaklar",
    "Outstanding balance past due": "Vadesi geçmiş açık bakiye",
    "Doubtful Receivables": "Şüpheli Alacaklar",
    "Receivables under collection risk": "Tahsilat riski altındaki alacaklar",
    "Bad Debt Exposure": "Değersiz Alacak Riski",
    "Accounting write-off total": "Muhasebe kayıt silme toplamı",
    "Net revenue after issued returns": "Kesilen iadeler sonrası net gelir",
    "Collections by Transport Mode": "Taşıma Moduna Göre Tahsilatlar",
    "Incoming payments and pending amounts across Ocean, Road and Air": "Denizyolu, karayolu ve havayolundaki gelen ödemeler ve bekleyen tutarlar",
    "Most frequently collected logistics services": "En sık tahsilat yapılan lojistik hizmetleri",
    "payments": "ödeme",
    "Collection Filters": "Tahsilat Filtreleri",
    "Search and segment payments by shipment, customer, reference, status and method.": "Ödemeleri sevkiyat, müşteri, referans, durum ve yönteme göre arayın ve filtreleyin.",
    "Shipment, invoice, customer, reference...": "Sevkiyat, fatura, müşteri, referans...",
    "All Statuses": "Tüm Durumlar",
    "Payment Method": "Ödeme Yöntemi",
    "All Methods": "Tüm Yöntemler",
    "COLLECTIONS": "TAHSİLAT",
    "Payment records": "Ödeme kayıtları",
    "Matched rate": "Eşleşme oranı",
    "Invoice value": "Fatura değeri",
    "Payment reference": "Ödeme referansı",
    "COLLECTION DATE": "TAHSİLAT TARİHİ",
    "Value date": "Valör tarihi",
    "Incoming payment": "Gelen ödeme",
    "NET RECEIVABLE": "NET ALACAK",
    "Credit due": "Alacak bakiyesi",
    "METHOD": "YÖNTEM",
    "BANK": "BANKA",
    "REFERENCE": "REFERANS",
    "Bank transaction ref.": "Banka işlem referansı",
    "View related invoice": "İlgili faturayı görüntüle",
    "Manage collection risk": "Tahsilat riskini yönet",
    "No collectible balance remains": "Tahsil edilebilir bakiye kalmadı",
    "Add Collection for Invoice": "Fatura İçin Tahsilat Ekle",
    "Add Collection": "Tahsilat Ekle",
    "Register an incoming customer payment.": "Gelen müşteri ödemesini kaydedin.",
    "Collection Amount": "Tahsilat Tutarı",
    "Collection Date": "Tahsilat Tarihi",
    "Bank Transfer": "Banka Havalesi",
    "Cash": "Nakit",
    "Credit Card": "Kredi Kartı",
    "Cheque": "Çek",
    "Reference No": "Referans No",
    "Note": "Not",
    "Save Collection": "Tahsilatı Kaydet",
    "Collection Risk Management": "Tahsilat Risk Yönetimi",
    "Update receivable risk": "Alacak riskini güncelle",
    "Net Balance": "Net Bakiye",
    "Days Overdue": "Gecikme Günü",
    "Reason": "Neden",
    "Expected Recovery": "Beklenen Tahsilat",
    "Provision Amount": "Karşılık Tutarı",
    "Written-Off Amount": "Kayıttan Düşülen Tutar",
    "Saving...": "Kaydediliyor...",
    "Save Risk Status": "Risk Durumunu Kaydet",
    "This invoice has no collectible balance after issued returns.": "Kesilen iadeler sonrasında bu faturada tahsil edilebilir bakiye bulunmuyor.",
    "This invoice has no outstanding collectible balance.": "Bu faturada açık tahsil edilebilir bakiye bulunmuyor.",
    "Please open Add Collection from an invoice row so the payment can be linked to an invoice.": "Ödemenin bir faturaya bağlanabilmesi için tahsilat işlemini ilgili fatura satırından açın.",
    "Collection amount must be greater than zero.": "Tahsilat tutarı sıfırdan büyük olmalıdır.",
    "Reference number is required.": "Referans numarası zorunludur.",
    "Invoice document could not be found for": "Fatura belgesi bulunamadı:",
    "Collection amount cannot exceed the net collectible balance": "Tahsilat tutarı net tahsil edilebilir bakiyeyi aşamaz",
    "Collection could not be saved.": "Tahsilat kaydedilemedi.",
    "A reason is required.": "Neden alanı zorunludur.",
    "Risk amounts cannot exceed the net collectible balance.": "Risk tutarları net tahsil edilebilir bakiyeyi aşamaz.",
    "Collection risk could not be saved.": "Tahsilat riski kaydedilemedi.",
    "CORPORATE SUPPLIER COST CONTROL": "KURUMSAL TEDARİKÇİ MALİYET KONTROLÜ",
    "Manage expected supplier costs, actual invoices, variances, tolerance controls, approvals and payment readiness from one banking-grade workspace.": "Beklenen tedarikçi maliyetlerini, gerçekleşen faturaları, farkları, tolerans kontrollerini, onayları ve ödeme hazırlığını tek bir kurumsal çalışma alanından yönetin.",
    "cost records": "maliyet kaydı",
    "return lines": "iade satırı",
    "COST VARIANCE": "MALİYET FARKI",
    "Approval rate": "Onay oranı",
    "Refresh supplier costs": "Tedarikçi maliyetlerini yenile",
    "SUPPLIER COSTS": "TEDARİKÇİ MALİYETLERİ",
    "of filtered records": "filtrelenmiş kayıtların",
    "Cost Lines": "Maliyet Satırları",
    "Filtered supplier cost records": "Filtrelenmiş tedarikçi maliyet kayıtları",
    "Planned supplier exposure": "Planlanan tedarikçi yükümlülüğü",
    "Received supplier invoice total": "Alınan tedarikçi faturası toplamı",
    "missing invoices": "eksik fatura",
    "approval rate": "onay oranı",
    "Purchase cost linked to master jobs": "Ana işlere bağlı satın alma maliyeti",
    "lines already included": "satır zaten dahil",
    "Supplier Costs by Transport Mode": "Taşıma Moduna Göre Tedarikçi Maliyetleri",
    "Expected and actual supplier costs across Ocean, Road and Air": "Denizyolu, karayolu ve havayolu bazında beklenen ve gerçekleşen tedarikçi maliyetleri",
    "Supplier cost distribution by logistics service": "Lojistik hizmetine göre tedarikçi maliyet dağılımı",
    "Supplier Cost Filters": "Tedarikçi Maliyet Filtreleri",
    "Search and segment supplier costs by shipment, supplier, invoice, approval, payment and tolerance.": "Tedarikçi maliyetlerini sevkiyat, tedarikçi, fatura, onay, ödeme ve toleransa göre arayın ve filtreleyin.",
    "Shipment, supplier, item...": "Sevkiyat, tedarikçi, kalem...",
    "All Approval Statuses": "Tüm Onay Durumları",
    "All Payment Statuses": "Tüm Ödeme Durumları",
    "All Tolerance Statuses": "Tüm Tolerans Durumları",
    "supplier cost / return records": "tedarikçi maliyet / iade kaydı",
    "Supplier Cost": "Tedarikçi Maliyeti",
    "COST ITEM": "MALİYET KALEMİ",
    "MASTER COST": "ANA MALİYET",
    "No planned cost": "Planlanan maliyet yok",
    "Planned cost": "Planlanan maliyet",
    "Cost reversal applied": "Maliyet ters kaydı uygulandı",
    "Pending return · not applied": "Bekleyen iade · uygulanmadı",
    "Supplier invoice": "Tedarikçi faturası",
    "Supplier maturity": "Tedarikçi vadesi",
    "View finance job": "Finans işini görüntüle",
    "Approve cost": "Maliyeti onayla",
    "Invoice already received": "Fatura zaten alındı",
    "Mark supplier invoice received": "Tedarikçi faturasını alındı olarak işaretle",
    "Add Supplier Cost Line": "Tedarikçi Maliyet Satırı Ekle",
    "Register expected and actual supplier cost details.": "Beklenen ve gerçekleşen tedarikçi maliyet detaylarını kaydedin.",
    "Service Type": "Hizmet Türü",
    "Supplier Type": "Tedarikçi Türü",
    "Carrier": "Taşıyıcı",
    "Customs Broker": "Gümrük Müşaviri",
    "Warehouse": "Depo",
    "Port / Terminal": "Liman / Terminal",
    "Cost Item": "Maliyet Kalemi",
    "Cost Code": "Maliyet Kodu",
    "Expected Amount": "Beklenen Tutar",
    "Actual Invoice Amount": "Gerçekleşen Fatura Tutarı",
    "Tolerance %": "Tolerans %",
    "Received": "Alındı",
    "Save Cost Line": "Maliyet Satırını Kaydet",
    "Finance Job ID not found. Supplier cost record must be linked with financeJobId.": "Finance Job ID bulunamadı. Tedarikçi maliyet kaydı financeJobId ile ilişkilendirilmelidir.",
    "This cost line is not saved in DB yet.": "Bu maliyet satırı henüz veritabanına kaydedilmedi.",
    "Cost approval could not be saved.": "Maliyet onayı kaydedilemedi.",
    "Supplier invoice status could not be saved.": "Tedarikçi fatura durumu kaydedilemedi.",
    "Cost item is required.": "Maliyet kalemi zorunludur.",
    "Expected amount is required.": "Beklenen tutar zorunludur.",
    "CORPORATE PAYABLES CONTROL": "KURUMSAL BORÇ KONTROLÜ",
    "Payables Management": "Borç Yönetimi",
    "Manage supplier debt, maturity planning, payment priorities, master-cost relationships and overdue exposure from one banking-grade workspace.": "Tedarikçi borçlarını, vade planlamasını, ödeme önceliklerini, ana maliyet ilişkilerini ve vadesi geçmiş yükümlülükleri tek bir kurumsal çalışma alanından yönetin.",
    "payable records": "borç kaydı",
    "OPEN PAYABLES": "AÇIK BORÇLAR",
    "Payment rate": "Ödeme oranı",
    "Refresh payables": "Borçları yenile",
    "PAYABLES": "BORÇLAR",
    "paid": "ödendi",
    "Open supplier exposure by operation type.": "Operasyon tipine göre açık tedarikçi borçları.",
    "Filtered supplier liabilities": "Filtrelenmiş tedarikçi yükümlülükleri",
    "Supplier credit": "Tedarikçi alacağı",
    "Remaining supplier exposure": "Kalan tedarikçi yükümlülüğü",
    "Past due supplier debt": "Vadesi geçmiş tedarikçi borcu",
    "Net of issued purchase returns": "Kesilmiş alış iadeleri sonrası net",
    "records already included": "kayıt zaten dahil",
    "Critical": "Kritik",
    "High-priority suppliers": "Yüksek öncelikli tedarikçiler",
    "Open payables by service configuration.": "Servis yapılandırmasına göre açık borçlar.",
    "Payment Schedule": "Ödeme Takvimi",
    "Open supplier balances grouped by maturity.": "Açık tedarikçi bakiyelerinin vadeye göre dağılımı.",
    "Payable Filters": "Borç Filtreleri",
    "Search and segment supplier liabilities by payment, approval and due bucket.": "Tedarikçi yükümlülüklerini ödeme, onay ve vade grubuna göre arayın ve filtreleyin.",
    "Shipment, invoice, supplier...": "Sevkiyat, fatura, tedarikçi...",
    "All Invoice Origins": "Tüm Fatura Kaynakları",
    "Due Bucket": "Vade Grubu",
    "All Due Buckets": "Tüm Vade Grupları",
    "Due Today": "Bugün Vadeli",
    "This Week": "Bu Hafta",
    "This Month": "Bu Ay",
    "Later": "Daha Sonra",
    "SUPPLIER / INVOICE": "TEDARİKÇİ / FATURA",
    "DUE / BUCKET": "VADE / GRUP",
    "PRIORITY": "ÖNCELİK",
    "Open": "Açık",
    "Credit": "Alacak",
    "No due date": "Vade tarihi yok",
    "Due today": "Bugün vadeli",
    "days left": "gün kaldı",
    "Supplier credit must be reconciled": "Tedarikçi alacağı mahsuplaştırılmalı",
    "Payable fully returned": "Borç tamamen iade edildi",
    "Manual invoice ID not found.": "Manuel fatura ID'si bulunamadı.",
    "Finance Job ID not found. Payable record must be linked with financeJobId.": "Finance Job ID bulunamadı. Borç kaydı financeJobId ile ilişkilendirilmelidir.",
    "Return invoice ID not found.": "İade faturası ID'si bulunamadı.",
    "Payable ID not found!": "Borç ID'si bulunamadı!",
    "Payment status could not be updated.": "Ödeme durumu güncellenemedi.",
    "CORPORATE INVOICE OPERATIONS": "KURUMSAL FATURA OPERASYONLARI",
    "Invoice Details": "Fatura Detayları",
    "Review customer invoices, transport modes, shipment items, profitability, document status and operational ownership from one professional workspace.": "Müşteri faturalarını, taşıma modlarını, sevkiyat kalemlerini, kârlılığı, belge durumunu ve operasyonel sorumluluğu tek bir profesyonel çalışma alanından inceleyin.",
    "invoice records": "fatura kaydı",
    "TOTAL INVOICE REVENUE": "TOPLAM FATURA GELİRİ",
    "Refresh invoices": "Faturaları yenile",
    "Filtered invoice records": "Filtrelenmiş fatura kayıtları",
    "Total invoiced value": "Toplam faturalanan değer",
    "PDF Coverage": "PDF Kapsamı",
    "missing documents": "eksik belge",
    "Invoice revenue and gross profit comparison.": "Fatura geliri ve brüt kâr karşılaştırması.",
    "Distribution of invoice shipment services.": "Faturalı sevkiyat hizmetlerinin dağılımı.",
    "Search and segment invoices by shipment, customer, transport mode and PDF status.": "Faturaları sevkiyat, müşteri, taşıma modu ve PDF durumuna göre arayın ve filtreleyin.",
    "Shipment, customer, email, invoice...": "Sevkiyat, müşteri, e-posta, fatura...",
    "PDF Status": "PDF Durumu",
    "All PDF Statuses": "Tüm PDF Durumları",
    "PDF Available": "PDF Mevcut",
    "PDF Missing": "PDF Eksik",
    "INVOICE ITEMS": "FATURA KALEMLERİ",
    "FINANCIALS": "FİNANSALLAR",
    "CREATED BY": "OLUŞTURAN",
    "DATE SENT": "GÖNDERİM TARİHİ",
    "Unnamed item": "İsimsiz kalem",
    "No invoice items": "Fatura kalemi yok",
    "more": "daha",
    "Invoice owner": "Fatura sorumlusu",
    "Delivery timestamp": "Gönderim zamanı",
    "Open invoice PDF": "Fatura PDF'ini aç",
    "Delete invoice": "Faturayı sil",
    "Are you sure you want to cancel this manual invoice?": "Bu manuel faturayı iptal etmek istediğinize emin misiniz?",
    "Are you sure you want to delete this invoice?": "Bu faturayı silmek istediğinize emin misiniz?",
    "Invoice could not be deleted.": "Fatura silinemedi.",
    "Send to EDM (e-Fatura/e-Arşiv)": "EDM'ye gönder (e-Fatura/e-Arşiv)",
    "Sent to EDM": "EDM'ye gönderildi",
    "EDM send failed": "EDM gönderimi başarısız oldu",
    "This invoice was already sent to EDM.": "Bu fatura EDM'ye zaten gönderildi.",
    "Send this invoice to EDM as e-Fatura/e-Arşiv? This cannot be undone.": "Bu fatura EDM'ye e-Fatura/e-Arşiv olarak gönderilsin mi? Bu işlem geri alınamaz.",
    "Invoice sent to EDM successfully.": "Fatura EDM'ye başarıyla gönderildi.",
    "Invoice could not be sent to EDM.": "Fatura EDM'ye gönderilemedi.",
    "An unexpected error occurred.": "Beklenmeyen bir hata oluştu.",
    "CORPORATE BANK OPERATIONS": "KURUMSAL BANKA OPERASYONLARI",
    "Filenders Bank Details": "Filenders Banka Bilgileri",
    "Manage company bank accounts, currencies, IBAN, SWIFT codes and Company Cash connections from one professional workspace.": "Şirket banka hesaplarını, para birimlerini, IBAN ve SWIFT kodlarını ve Şirket Kasası bağlantılarını tek bir profesyonel çalışma alanından yönetin.",
    "bank accounts": "banka hesabı",
    "connected to Company Cash": "Şirket Kasası'na bağlı",
    "TR IBAN checksum is invalid. Please check the number.": "TR IBAN kontrol basamağı geçersiz. Lütfen numarayı kontrol edin.",
    "TOTAL BANK ACCOUNTS": "TOPLAM BANKA HESABI",
    "Add New Account": "Yeni Hesap Ekle",
    "Refresh bank accounts": "Banka hesaplarını yenile",
    "TRY Accounts": "TRY Hesapları",
    "Turkish Lira accounts": "Türk Lirası hesapları",
    "USD Accounts": "USD Hesapları",
    "US Dollar accounts": "ABD Doları hesapları",
    "EUR Accounts": "EUR Hesapları",
    "Euro accounts": "Euro hesapları",
    "GBP Accounts": "GBP Hesapları",
    "British Pound accounts": "İngiliz Sterlini hesapları",
    "Bank Accounts": "Banka Hesapları",
    "Manage bank accounts, balances and Company Cash connections.": "Banka hesaplarını, bakiyeleri ve Şirket Kasası bağlantılarını yönetin.",
    "Export Excel": "Excel'e Aktar",
    "Bank, currency, IBAN, branch, SWIFT or cash status...": "Banka, para birimi, IBAN, şube, SWIFT veya kasa durumu...",
    "Connected": "Bağlı",
    "Not Connected": "Bağlı Değil",
    "CURRENCY": "PARA BİRİMİ",
    "BRANCH": "ŞUBE",
    "CASH STATUS": "KASA DURUMU",
    "Bank branch": "Banka şubesi",
    "Not connected": "Bağlı değil",
    "Current balance": "Güncel bakiye",
    "Open Company Cash": "Şirket Kasası'nı Aç",
    "Connect to Company Cash": "Şirket Kasası'na Bağla",
    "Edit bank account": "Banka hesabını düzenle",
    "Connected accounts cannot be deleted": "Bağlı hesaplar silinemez",
    "Delete bank account": "Banka hesabını sil",
    "Add New Bank Account": "Yeni Banka Hesabı Ekle",
    "Create a new company bank account.": "Yeni bir şirket banka hesabı oluşturun.",
    "Bank Name": "Banka Adı",
    "Example: T. GARANTİ BANKASI": "Örnek: T. GARANTİ BANKASI",
    "TR IBAN - 26 characters": "TR IBAN - 26 karakter",
    "SWIFT Code": "SWIFT Kodu",
    "Example: TGBATRISXXX": "Örnek: TGBATRISXXX",
    "8 or 11 characters": "8 veya 11 karakter",
    "Example: MERSİN SANAYİ": "Örnek: MERSİN SANAYİ",
    "After creating the bank account, you can connect it to Company Cash and define its opening balance.": "Banka hesabını oluşturduktan sonra Şirket Kasası'na bağlayabilir ve açılış bakiyesini tanımlayabilirsiniz.",
    "Add Account": "Hesap Ekle",
    "Create a Cash Account linked to this bank account.": "Bu banka hesabına bağlı bir Kasa Hesabı oluşturun.",
    "No branch": "Şube yok",
    "No SWIFT": "SWIFT yok",
    "Opening Balance": "Açılış Bakiyesi",
    "Initial balance of this bank account in Company Cash.": "Bu banka hesabının Şirket Kasası içindeki başlangıç bakiyesi.",
    "Example: Main EUR collection account": "Örnek: Ana EUR tahsilat hesabı",
    "After connecting, future balance changes should be managed through Company Cash transactions.": "Bağlantıdan sonra bakiye değişiklikleri Şirket Kasası işlemleri üzerinden yönetilmelidir.",
    "Connect Account": "Hesabı Bağla",
    "Edit Bank Account": "Banka Hesabını Düzenle",
    "Update bank account information.": "Banka hesabı bilgilerini güncelleyin.",
    "This bank account is connected to Company Cash. Currency cannot be changed.": "Bu banka hesabı Şirket Kasası'na bağlıdır. Para birimi değiştirilemez.",
    "Currency is locked because this account is connected to Company Cash.": "Bu hesap Şirket Kasası'na bağlı olduğu için para birimi kilitlidir.",
    "Delete Bank Account?": "Banka Hesabı Silinsin mi?",
    "will be permanently deleted. This action cannot be undone.": "kalıcı olarak silinecektir. Bu işlem geri alınamaz.",
    "TR IBAN must contain 26 characters.": "TR IBAN 26 karakter içermelidir.",
    "SWIFT must contain 8 or 11 characters.": "SWIFT 8 veya 11 karakter içermelidir.",
    "Please complete the required fields correctly.": "Lütfen zorunlu alanları doğru şekilde doldurun.",
    "Bank account created successfully.": "Banka hesabı başarıyla oluşturuldu.",
    "Bank account could not be created.": "Banka hesabı oluşturulamadı.",
    "Bank account updated successfully.": "Banka hesabı başarıyla güncellendi.",
    "Bank account could not be updated.": "Banka hesabı güncellenemedi.",
    "This bank account is connected to Company Cash and cannot be deleted.": "Bu banka hesabı Şirket Kasası'na bağlıdır ve silinemez.",
    "Bank account deleted successfully.": "Banka hesabı başarıyla silindi.",
    "Bank account could not be deleted.": "Banka hesabı silinemedi.",
    "Opening balance must be a valid number.": "Açılış bakiyesi geçerli bir sayı olmalıdır.",
    "Bank account connected to Company Cash successfully.": "Banka hesabı Şirket Kasası'na başarıyla bağlandı.",
    "Bank account could not be connected to Company Cash.": "Banka hesabı Şirket Kasası'na bağlanamadı.",
    "Bank details could not be loaded.": "Banka bilgileri yüklenemedi.",
    "Cheques": "Çekler",
    "Manage received and issued cheques, maturity dates, portfolio status and Company Cash collections or payments.": "Alınan ve verilen çekleri, vade tarihlerini, portföy durumlarını ve Şirket Kasası tahsilat veya ödemelerini yönetin.",
    "RECEIVED CHEQUE PORTFOLIO": "ALINAN ÇEK PORTFÖYÜ",
    "cheques": "çek",
    "Upcoming cheque maturities": "Yaklaşan çek vadeleri",
    "Unsettled overdue cheques": "Ödenmemiş vadesi geçmiş çekler",
    "Cheque Portfolio": "Çek Portföyü",
    "Review received and issued cheques, due dates, portfolio movements and Company Cash settlements.": "Alınan ve verilen çekleri, vade tarihlerini, portföy hareketlerini ve Şirket Kasası mutabakatlarını inceleyin.",
    "Cheque, bank, branch, drawer, beneficiary...": "Çek, banka, şube, keşideci, lehtar...",
    "Deposited": "Bankaya Verildi",
    "Bounced": "Karşılıksız",
    "Cancelled": "İptal Edildi",
    "CHEQUE": "ÇEK",
    "PARTY": "TARAF",
    "Drawer": "Keşideci",
    "Beneficiary": "Lehtar",
    "Collect cheque": "Çeki tahsil et",
    "Pay cheque": "Çeki öde",
    "Endorsed cheque cannot be collected to Company Cash": "Ciro edilmiş çek Şirket Kasası'na tahsil edilemez",
    "Bounced cheque cannot be collected": "Karşılıksız çek tahsil edilemez",
    "Cheque cannot be settled in its current status": "Çek mevcut durumunda kapatılamaz",
    "Settled cheque cannot be edited": "Kapatılmış çek düzenlenemez",
    "Edit cheque": "Çeki düzenle",
    "Settled cheque cannot be deleted": "Kapatılmış çek silinemez",
    "Delete cheque": "Çeki sil",
    "Edit Cheque": "Çeki Düzenle",
    "Add Cheque": "Çek Ekle",
    "Register received or issued cheque information.": "Alınan veya verilen çek bilgilerini kaydedin.",
    "Cheque No": "Çek No",
    "Issue Date": "Keşide Tarihi",
    "Account No": "Hesap No",
    "Drawer Name": "Keşideci Adı",
    "Beneficiary Name": "Lehtar Adı",
    "Direction cannot be changed after creation.": "Oluşturulduktan sonra yön değiştirilemez.",
    "Person/company issuing the cheque.": "Çeki düzenleyen kişi/şirket.",
    "Person/company receiving the cheque.": "Çeki alan kişi/şirket.",
    "Collected/Paid status can only be created through settlement.": "Tahsil Edildi/Ödendi durumu yalnızca kapatma işlemiyle oluşturulabilir.",
    "An endorsed cheque has been transferred to another party and cannot be collected directly into Company Cash.": "Ciro edilmiş çek başka bir tarafa devredilmiştir ve doğrudan Şirket Kasası'na tahsil edilemez.",
    "A bounced cheque cannot be settled into Company Cash until its business status is resolved.": "Karşılıksız çekin ticari durumu çözülmeden Şirket Kasası'na işlenemez.",
    "A received cheque does not increase Company Cash when it is registered. Company Cash increases only after the cheque is collected.": "Alınan çek kaydedildiğinde Şirket Kasası bakiyesini artırmaz. Bakiye yalnızca çek tahsil edildiğinde artar.",
    "An issued cheque does not reduce Company Cash when it is registered. Company Cash decreases only when the cheque is paid.": "Verilen çek kaydedildiğinde Şirket Kasası bakiyesini azaltmaz. Bakiye yalnızca çek ödendiğinde azalır.",
    "Update Cheque": "Çeki Güncelle",
    "Collect Cheque": "Çeki Tahsil Et",
    "Pay Cheque": "Çeki Öde",
    "This operation will update Company Cash automatically.": "Bu işlem Şirket Kasası'sını otomatik olarak güncelleyecektir.",
    "Amount to be added to Company Cash": "Şirket Kasası'na eklenecek tutar",
    "Amount to be deducted from Company Cash": "Şirket Kasasından düşülecek tutar",
    "Collection Account": "Tahsilat Hesabı",
    "Payment Account": "Ödeme Hesabı",
    "No suitable Company Cash account": "Uygun Şirket Kasası hesabı yok",
    "COMPANY CASH PREVIEW": "COMPANY CASH ÖNİZLEME",
    "Current Balance": "Güncel Bakiye",
    "Balance After Settlement": "Kapatma Sonrası Bakiye",
    "Selected Company Cash account has insufficient balance to pay this issued cheque.": "Seçilen Şirket Kasası hesabında bu verilen çeki ödemek için yeterli bakiye yok.",
    "After confirmation, status becomes Collected and a Company Cash Cash In transaction with payment method Cheque is created.": "Onaydan sonra durum Tahsil Edildi olur ve ödeme yöntemi Çek olan bir Şirket Kasası Nakit Giriş işlemi oluşturulur.",
    "After confirmation, status becomes Paid and a Company Cash Cash Out transaction with payment method Cheque is created.": "Onaydan sonra durum Ödendi olur ve ödeme yöntemi Çek olan bir Şirket Kasası Nakit Çıkış işlemi oluşturulur.",
    "Delete Cheque?": "Çek Silinsin mi?",
    "will be permanently deleted.": "kalıcı olarak silinecektir.",
    "Collected or paid cheques cannot be deleted because they already affected Company Cash.": "Tahsil edilmiş veya ödenmiş çekler Şirket Kasası'nı etkilediği için silinemez.",
    "Cheques could not be loaded.": "Çekler yüklenemedi.",
    "Company Cash accounts could not be loaded.": "Şirket Kasası hesapları yüklenemedi.",
    "Cheque data could not be loaded.": "Çek verileri yüklenemedi.",
    "Settled cheques cannot be edited.": "Kapatılmış çekler düzenlenemez.",
    "Cheque number is required.": "Çek numarası zorunludur.",
    "Cheque amount must be greater than zero.": "Çek tutarı sıfırdan büyük olmalıdır.",
    "Due date is required.": "Vade tarihi zorunludur.",
    "Selected status is not valid for this cheque direction.": "Seçilen durum bu çek yönü için geçerli değildir.",
    "Cheque updated successfully.": "Çek başarıyla güncellendi.",
    "Cheque created successfully.": "Çek başarıyla oluşturuldu.",
    "Cheque could not be saved.": "Çek kaydedilemedi.",
    "Only received cheques in Portfolio or Deposited status can be collected.": "Yalnızca Portföy veya Bankaya Verildi durumundaki alınan çekler tahsil edilebilir.",
    "Only issued cheques in Portfolio status can be paid.": "Yalnızca Portföy durumundaki verilen çekler ödenebilir.",
    "Cheque can no longer be settled in its current status.": "Çek mevcut durumunda artık kapatılamaz.",
    "Please select a Company Cash account.": "Lütfen bir Şirket Kasası hesabı seçin.",
    "Selected Company Cash account could not be found.": "Seçilen Şirket Kasası hesabı bulunamadı.",
    "Selected Company Cash account is inactive.": "Seçilen Şirket Kasası hesabı pasif.",
    "Cheque and Company Cash account currencies must match.": "Çek ve Şirket Kasası hesabının para birimleri aynı olmalıdır.",
    "Selected account has insufficient balance.": "Seçilen hesapta yeterli bakiye yok.",
    "Cheque collected successfully and added to Company Cash.": "Çek başarıyla tahsil edildi ve Şirket Kasası'na eklendi.",
    "Cheque paid successfully and deducted from Company Cash.": "Çek başarıyla ödendi ve Şirket Kasasından düşüldü.",
    "Cheque could not be settled.": "Çek kapatılamadı.",
    "Cheque deleted successfully.": "Çek başarıyla silindi.",
    "Cheque could not be deleted.": "Çek silinemedi.",
    "Cash Account": "Kasa Hesabı",
    "Bank Account": "Banka Hesabı",
    "Physical Cash": "Fiziksel Kasa",
    "Active": "Aktif",
    "Inactive": "Pasif",
    "Company Cash": "Şirket Kasası",
    "Manage company bank accounts, physical cash, collections, payments, Treasury settlements and internal Virman transfers from one workspace.": "Şirket banka hesaplarını, fiziksel kasayı, tahsilatları, ödemeleri, hazine mutabakatlarını ve dahili virman transferlerini tek bir çalışma alanından yönetin.",
    "transactions": "işlem",
    "cash registers": "kasa",
    "CURRENT CASH POSITION": "GÜNCEL NAKİT POZİSYONU",
    "Cash In": "Nakit Giriş",
    "Cash Out": "Nakit Çıkış",
    "Net Cash Flow": "Net Nakit Akışı",
    "New Transaction": "Yeni İşlem",
    "Turkish Lira": "Türk Lirası",
    "US Dollar": "ABD Doları",
    "Euro": "Euro",
    "British Pound": "İngiliz Sterlini",
    "Accounts": "Hesaplar",
    "bank": "banka",
    "physical cash": "fiziksel kasa",
    "inflow": "giriş",
    "outflow": "çıkış",
    "Current month": "Cari ay",
    "Virman is excluded from cash flow": "Virman nakit akışına dahil edilmez",
    "TRY Balance": "TRY Bakiyesi",
    "USD Balance": "USD Bakiyesi",
    "EUR Balance": "EUR Bakiyesi",
    "GBP Balance": "GBP Bakiyesi",
    "Total Turkish Lira liquidity": "Toplam Türk Lirası likiditesi",
    "Total US Dollar liquidity": "Toplam ABD Doları likiditesi",
    "Total Euro liquidity": "Toplam Euro likiditesi",
    "Total British Pound liquidity": "Toplam İngiliz Sterlini likiditesi",
    "Bank & Cash Accounts": "Banka & Kasa Hesapları",
    "Bank accounts are connected through Bank Accounts. Physical cash registers can be created here.": "Banka hesapları Banka Hesapları ekranı üzerinden bağlanır. Fiziksel kasalar burada oluşturulabilir.",
    "Bank": "Banka",
    "Add Cash Register": "Kasa Ekle",
    "No Company Cash accounts have been created yet.": "Henüz Şirket Kasası hesabı oluşturulmadı.",
    "Treasury Transactions": "Hazine İşlemleri",
    "Manual cash movements, Virman, credit card, POS, cheque and promissory note settlements are displayed together.": "Manuel nakit hareketleri, virman, kredi kartı, POS, çek ve senet işlemleri birlikte görüntülenir.",
    "Transaction, account, source, reference...": "İşlem, hesap, kaynak, referans...",
    "Type": "Tür",
    "All Types": "Tüm Türler",
    "Adjustment": "Düzeltme",
    "Treasury generated transactions are protected from manual edit/delete.": "Hazine modüllerinin oluşturduğu işlemler manuel düzenleme/silmeye karşı korunur.",
    "TRANSACTION": "İŞLEM",
    "PAYMENT METHOD": "ÖDEME YÖNTEMİ",
    "FROM / ACCOUNT": "KAYNAK / HESAP",
    "TO": "HEDEF",
    "CATEGORY": "KATEGORİ",
    "SOURCE": "KAYNAK",
    "DESCRIPTION": "AÇIKLAMA",
    "Account": "Hesap",
    "POS": "POS",
    "Promissory Note": "Senet",
    "Virman": "Virman",
    "Internal Transfer": "Dahili Transfer",
    "Edit transaction": "İşlemi düzenle",
    "Delete transaction": "İşlemi sil",
    "This transaction is managed by its Treasury source module": "Bu işlem kendi Hazine kaynak modülü tarafından yönetilir",
    "Edit Cash Transaction": "Kasa İşlemini Düzenle",
    "New Virman": "Yeni Virman",
    "New Cash Transaction": "Yeni Kasa İşlemi",
    "Update a manual Company Cash transaction.": "Manuel Şirket Kasası işlemini güncelleyin.",
    "Transfer money between company-owned accounts.": "Şirkete ait hesaplar arasında para transferi yapın.",
    "Record a direct bank or physical cash movement.": "Doğrudan banka veya fiziksel kasa hareketi kaydedin.",
    "Transaction Type": "İşlem Türü",
    "Virman - Internal Transfer": "Virman - Dahili Transfer",
    "Balance After Transaction": "İşlem Sonrası Bakiye",
    "Virman is an internal transfer between company accounts. It does not create company-wide Cash In or Cash Out.": "Virman şirket hesapları arasındaki dahili transferdir. Şirket genelinde Nakit Giriş veya Nakit Çıkış oluşturmaz.",
    "From Account": "Kaynak Hesap",
    "To Account": "Hedef Hesap",
    "Virman Amount": "Virman Tutarı",
    "FROM": "KAYNAK",
    "Source account has insufficient balance.": "Kaynak hesapta yeterli bakiye yok.",
    "Credit Card, POS, Cheque and Promissory Note transactions are generated from their own Treasury modules. Manual Company Cash transactions are limited to Bank and Physical Cash.": "Kredi Kartı, POS, Çek ve Senet işlemleri kendi Hazine modüllerinden oluşturulur. Manuel Şirket Kasası işlemleri yalnızca Banka ve Fiziksel Kasa ile sınırlıdır.",
    "Update Transaction": "İşlemi Güncelle",
    "Complete Virman": "Virmanı Tamamla",
    "Save Transaction": "İşlemi Kaydet",
    "Create a physical company cash account.": "Fiziksel şirket kasa hesabı oluşturun.",
    "Cash Register Name": "Kasa Adı",
    "Head Office TRY Cash": "Merkez Ofis TRY Kasa",
    "Head office physical cash register...": "Merkez ofis fiziksel kasa...",
    "Bank accounts are created and connected from Bank Accounts. This form should only be used for physical company cash registers.": "Banka hesapları Banka Hesapları ekranından oluşturulur ve bağlanır. Bu form yalnızca fiziksel şirket kasaları için kullanılmalıdır.",
    "Delete Transaction?": "İşlem Silinsin mi?",
    "will be permanently deleted. Its effect on the account balance will be reversed automatically.": "kalıcı olarak silinecektir. Hesap bakiyesi üzerindeki etkisi otomatik olarak geri alınacaktır.",
    "Only direct Bank or Cash transactions can be deleted here. POS, Cheque, Credit Card, Promissory Note and Virman transactions must remain linked to their Treasury source.": "Burada yalnızca doğrudan Banka veya Kasa işlemleri silinebilir. POS, Çek, Kredi Kartı, Senet ve Virman işlemleri Hazine kaynaklarına bağlı kalmalıdır.",
    "Delete Transaction": "İşlemi Sil",
    "Company Cash data could not be loaded.": "Şirket Kasası verileri yüklenemedi.",
    "This transaction is managed by another Treasury module and cannot be edited from Company Cash.": "Bu işlem başka bir Hazine modülü tarafından yönetiliyor ve Şirket Kasası üzerinden düzenlenemez.",
    "Please select a source account.": "Lütfen kaynak hesap seçin.",
    "Please select an account.": "Lütfen bir hesap seçin.",
    "Amount must be greater than zero.": "Tutar sıfırdan büyük olmalıdır.",
    "Please select a destination account.": "Lütfen hedef hesap seçin.",
    "Source or destination account could not be found.": "Kaynak veya hedef hesap bulunamadı.",
    "Virman can only be made between accounts with the same currency.": "Virman yalnızca aynı para birimindeki hesaplar arasında yapılabilir.",
    "Virman completed successfully.": "Virman başarıyla tamamlandı.",
    "Transaction updated successfully.": "İşlem başarıyla güncellendi.",
    "Transaction created successfully.": "İşlem başarıyla oluşturuldu.",
    "Transaction could not be saved.": "İşlem kaydedilemedi.",
    "Transaction deleted successfully.": "İşlem başarıyla silindi.",
    "Transaction could not be deleted.": "İşlem silinemedi.",
    "Cash account name is required.": "Kasa hesabı adı zorunludur.",
    "Opening balance is invalid.": "Açılış bakiyesi geçersiz.",
    "Physical cash account created successfully.": "Fiziksel kasa hesabı başarıyla oluşturuldu.",
    "Cash account could not be created.": "Kasa hesabı oluşturulamadı.",
    "Corporate Credit Cards": "Kurumsal Kredi Kartları",
    "Manage company credit cards, fixed card limits, available spending limits, outstanding debt, purchases and payments through Company Cash.": "Şirket kredi kartlarını, sabit kart limitlerini, kullanılabilir harcama limitlerini, açık borçları, harcamaları ve Şirket Kasası üzerinden yapılan ödemeleri yönetin.",
    "active cards": "aktif kart",
    "CURRENT CARD DEBT": "GÜNCEL KART BORCU",
    "Total Limit": "Toplam Limit",
    "Available": "Kullanılabilir",
    "Add Credit Card": "Kredi Kartı Ekle",
    "Active Cards": "Aktif Kartlar",
    "corporate cards": "kurumsal kart",
    "Fixed bank-defined credit limit": "Banka tarafından tanımlanan sabit kredi limiti",
    "Current Debt": "Güncel Borç",
    "Outstanding card debt": "Açık kart borcu",
    "Available Limit": "Kullanılabilir Limit",
    "Total limit minus current debt": "Toplam limit eksi güncel borç",
    "Credit Cards": "Kredi Kartları",
    "Manage corporate cards, purchases, available limits, debt and Company Cash payments.": "Kurumsal kartları, harcamaları, kullanılabilir limitleri, borcu ve Şirket Kasası ödemelerini yönetin.",
    "Card name, bank, holder, last four digits, currency...": "Kart adı, banka, kart sahibi, son dört hane, para birimi...",
    "credit cards": "kredi kartı",
    "With Debt": "Borçlu",
    "CARD": "KART",
    "CARD LIMIT": "KART LİMİTİ",
    "CURRENT DEBT": "GÜNCEL BORÇ",
    "AVAILABLE LIMIT": "KULLANILABİLİR LİMİT",
    "STATEMENT / DUE": "EKSTRE / VADE",
    "PAYMENT ACCOUNT": "ÖDEME HESABI",
    "No card holder": "Kart sahibi yok",
    "Statement": "Ekstre",
    "Not Linked": "Bağlı Değil",
    "Inactive card cannot be used": "Pasif kart kullanılamaz",
    "Record credit card purchase": "Kredi kartı harcaması kaydet",
    "Card has no available limit": "Kartın kullanılabilir limiti yok",
    "Inactive card cannot be paid": "Pasif karta ödeme yapılamaz",
    "Pay credit card debt": "Kredi kartı borcunu öde",
    "No outstanding debt": "Açık borç yok",
    "Edit credit card": "Kredi kartını düzenle",
    "Delete credit card": "Kredi kartını sil",
    "Card with debt cannot be deleted": "Borçlu kart silinemez",
    "Edit Credit Card": "Kredi Kartını Düzenle",
    "Update corporate credit card information.": "Kurumsal kredi kartı bilgilerini güncelleyin.",
    "Register a new corporate credit card.": "Yeni bir kurumsal kredi kartı kaydedin.",
    "Card Name": "Kart Adı",
    "Garanti Corporate Card": "Garanti Kurumsal Kart",
    "No Bank Selected": "Banka Seçilmedi",
    "Card Holder": "Kart Sahibi",
    "Company / Employee Name": "Şirket / Çalışan Adı",
    "Last 4 Digits": "Son 4 Hane",
    "Card Limit": "Kart Limiti",
    "Fixed bank-defined credit limit.": "Banka tarafından tanımlanan sabit kredi limiti.",
    "Debt only changes through purchases and payments.": "Borç yalnızca harcamalar ve ödemeler ile değişir.",
    "Current Available Limit": "Mevcut Kullanılabilir Limit",
    "Available after new limit": "Yeni limit sonrası kullanılabilir",
    "Statement Day": "Ekstre Günü",
    "Due Day": "Son Ödeme Günü",
    "Linked Payment Account": "Bağlı Ödeme Hesabı",
    "No Default Payment Account": "Varsayılan Ödeme Hesabı Yok",
    "Card Limit is the fixed bank-defined limit. Purchases increase Current Debt and reduce Available Limit. Paying card debt reduces Company Cash and restores the Available Limit.": "Kart Limiti, banka tarafından tanımlanan sabit limittir. Harcamalar Güncel Borcu artırır ve Kullanılabilir Limiti azaltır. Kart borcu ödendiğinde Şirket Kasası azalır ve Kullanılabilir Limit geri kazanılır.",
    "Update Credit Card": "Kredi Kartını Güncelle",
    "Credit Card Purchase": "Kredi Kartı Harcaması",
    "Record a company credit card purchase without affecting Company Cash.": "Şirket Kasasını etkilemeden şirket kredi kartı harcaması kaydedin.",
    "Purchase Amount": "Harcama Tutarı",
    "Debt After Purchase": "Harcama Sonrası Borç",
    "Available After Purchase": "Harcama Sonrası Kullanılabilir",
    "Purchase amount exceeds the available card limit.": "Harcama tutarı kullanılabilir kart limitini aşıyor.",
    "This purchase increases Current Debt but does not decrease Company Cash. Company Cash changes when the credit card debt is actually paid.": "Bu harcama Güncel Borcu artırır ancak Şirket Kasasını azaltmaz. Şirket Kasası yalnızca kredi kartı borcu gerçekten ödendiğinde değişir.",
    "Record Purchase": "Harcamayı Kaydet",
    "Pay Credit Card Debt": "Kredi Kartı Borcunu Öde",
    "Deduct payment from Company Cash and restore the credit card available limit.": "Ödemeyi Şirket Kasasından düşerek kredi kartının kullanılabilir limitini geri kazandırın.",
    "Payment Amount": "Ödeme Tutarı",
    "Pay Full Debt": "Borucun Tamamını Öde",
    "AFTER PAYMENT": "ÖDEME SONRASI",
    "Company Cash Balance": "Şirket Kasası Bakiyesi",
    "Card Debt": "Kart Borcu",
    "Payment cannot exceed current card debt of": "Ödeme, mevcut kart borcunu aşamaz:",
    "Selected Company Cash account does not have sufficient balance.": "Seçilen Şirket Kasası hesabında yeterli bakiye yok.",
    "Paying the card decreases Company Cash by the payment amount, decreases Current Debt by the same amount and automatically restores the Available Limit. The fixed Card Limit does not change.": "Kart ödemesi Şirket Kasası'nı ödeme tutarı kadar azaltır, Güncel Borcu aynı tutarda düşürür ve Kullanılabilir Limiti otomatik olarak geri kazandırır. Sabit Kart Limiti değişmez.",
    "Pay Credit Card": "Kredi Kartını Öde",
    "Delete Credit Card?": "Kredi Kartı Silinsin mi?",
    "Limit": "Limit",
    "Debt": "Borç",
    "A credit card can only be deleted when its current debt is zero.": "Kredi kartı yalnızca güncel borcu sıfır olduğunda silinebilir.",
    "Delete Credit Card": "Kredi Kartını Sil",
    "Credit cards could not be loaded.": "Kredi kartları yüklenemedi.",
    "Card name is required.": "Kart adı zorunludur.",
    "Last 4 digits must contain exactly four numbers.": "Son 4 hane tam olarak dört rakam içermelidir.",
    "Card limit is invalid.": "Kart limiti geçersiz.",
    "Card limit cannot be lower than current card debt.": "Kart limiti mevcut kart borcundan düşük olamaz.",
    "Statement day must be between 1 and 31.": "Ekstre günü 1 ile 31 arasında olmalıdır.",
    "Due day must be between 1 and 31.": "Son ödeme günü 1 ile 31 arasında olmalıdır.",
    "Credit card updated successfully.": "Kredi kartı başarıyla güncellendi.",
    "Credit card created successfully.": "Kredi kartı başarıyla oluşturuldu.",
    "Credit card could not be saved.": "Kredi kartı kaydedilemedi.",
    "Inactive credit card cannot be used.": "Pasif kredi kartı kullanılamaz.",
    "Credit card has no available limit.": "Kredi kartının kullanılabilir limiti yok.",
    "Purchase amount must be greater than zero.": "Harcama tutarı sıfırdan büyük olmalıdır.",
    "Purchase amount exceeds available card limit. Available": "Harcama tutarı kullanılabilir kart limitini aşıyor. Kullanılabilir",
    "Credit card purchase recorded successfully.": "Kredi kartı harcaması başarıyla kaydedildi.",
    "Credit card purchase could not be recorded.": "Kredi kartı harcaması kaydedilemedi.",
    "Inactive credit card cannot be paid.": "Pasif kredi kartına ödeme yapılamaz.",
    "Credit card has no outstanding debt.": "Kredi kartının açık borcu yok.",
    "Locked while the card has debt.": "Kartın borcu varken kilitli.",
    "Locked while pending collections exist.": "Bekleyen tahsilat varken kilitli.",
    "Due date cannot be earlier than the issue date.": "Vade tarihi, düzenleme/keşide tarihinden önce olamaz.",
    "Received Cheque Portfolio": "Alınan Çek Portföyü",
    "Issued Cheque Exposure": "Verilen Çek Yükümlülüğü",
    "Issued cheque exposure": "Verilen çek yükümlülüğü",
    "Please select a payment account.": "Lütfen bir ödeme hesabı seçin.",
    "Selected payment account could not be found.": "Seçilen ödeme hesabı bulunamadı.",
    "Payment amount must be greater than zero.": "Ödeme tutarı sıfırdan büyük olmalıdır.",
    "Payment cannot exceed current card debt. Current debt": "Ödeme mevcut kart borcunu aşamaz. Güncel borç",
    "Selected account has insufficient balance. Current balance": "Seçilen hesapta yeterli bakiye yok. Güncel bakiye",
    "Credit card and payment account currencies must match.": "Kredi kartı ve ödeme hesabı para birimleri aynı olmalıdır.",
    "Credit card debt payment completed successfully.": "Kredi kartı borç ödemesi başarıyla tamamlandı.",
    "Credit card payment could not be completed.": "Kredi kartı ödemesi tamamlanamadı.",
    "A credit card with outstanding debt cannot be deleted.": "Açık borcu bulunan kredi kartı silinemez.",
    "Credit card deleted successfully.": "Kredi kartı başarıyla silindi.",
    "Credit card could not be deleted.": "Kredi kartı silinemedi.",
    "POS Accounts": "POS Hesapları",
    "Manage physical and virtual POS accounts, customer card collections, commissions and settlement transfers to Company Cash.": "Fiziksel ve sanal POS hesaplarını, müşteri kart tahsilatlarını, komisyonları ve Şirket Kasası'na aktarılan mutabakat transferlerini yönetin.",
    "POS accounts": "POS hesabı",
    "pending settlements": "bekleyen mutabakat",
    "PENDING POS SETTLEMENTS": "BEKLEYEN POS MUTABAKATLARI",
    "Commission": "Komisyon",
    "Add POS": "POS Ekle",
    "Active POS": "Aktif POS",
    "Gross Collections": "Brüt Tahsilatlar",
    "card collection volume": "kart tahsilat hacmi",
    "Pending Settlement": "Bekleyen Mutabakat",
    "Waiting to enter Company Cash": "Şirket Kasası'na aktarılmayı bekliyor",
    "total POS commissions": "toplam POS komisyonu",
    "Configure settlement accounts, commission rates and merchant information.": "Mutabakat hesaplarını, komisyon oranlarını ve üye işyeri bilgilerini yapılandırın.",
    "New Collection": "Yeni Tahsilat",
    "POS, bank, merchant, currency or settlement account...": "POS, banka, üye işyeri, para birimi veya mutabakat hesabı...",
    "POS Collections": "POS Tahsilatları",
    "Pending collections do not affect Company Cash until the settlement operation is completed.": "Bekleyen tahsilatlar, mutabakat işlemi tamamlanana kadar Şirket Kasası'nı etkilemez.",
    "POS, reference, settlement account...": "POS, referans, mutabakat hesabı...",
    "Settled": "Mutabık",
    "COMMISSION": "KOMİSYON",
    "SETTLEMENT": "MUTABAKAT",
    "SETTLEMENT ACCOUNT": "MUTABAKAT HESABI",
    "PENDING": "BEKLEYEN",
    "Virtual POS": "Sanal POS",
    "Physical POS": "Fiziksel POS",
    "Merchant": "Üye İşyeri",
    "Same Day": "Aynı Gün",
    "Day": "Gün",
    "Inactive POS cannot receive collections": "Pasif POS tahsilat alamaz",
    "Record POS collection": "POS tahsilatı kaydet",
    "Edit POS": "POS'u düzenle",
    "Delete POS": "POS'u sil",
    "pending settlement(s) must be completed or cancelled first": "bekleyen mutabakat önce tamamlanmalı veya iptal edilmelidir",
    "GROSS": "BRÜT",
    "NET": "NET",
    "Not Found": "Bulunamadı",
    "Settle net amount to Company Cash": "Net tutarı Şirket Kasası'na aktar",
    "Only pending collections can be settled": "Yalnızca bekleyen tahsilatlar mutabık hale getirilebilir",
    "Cancel collection": "Tahsilatı iptal et",
    "Only pending collections can be cancelled": "Yalnızca bekleyen tahsilatlar iptal edilebilir",
    "Edit POS Account": "POS Hesabını Düzenle",
    "Add POS Account": "POS Hesabı Ekle",
    "Configure POS and Company Cash settlement information.": "POS ve Şirket Kasası mutabakat bilgilerini yapılandırın.",
    "POS Name": "POS Adı",
    "Garanti Virtual POS": "Garanti Sanal POS",
    "Merchant No": "Üye İşyeri No",
    "POS Type": "POS Türü",
    "Commission Rate": "Komisyon Oranı",
    "Settlement Days": "Mutabakat Günü",
    "Settlement Account": "Mutabakat Hesabı",
    "Only active": "Yalnızca aktif",
    "Company Cash accounts are shown.": "Şirket Kasası hesapları gösterilir.",
    "The settlement account is the Company Cash account that receives the net POS amount after commission.": "Mutabakat hesabı, komisyon sonrası net POS tutarını alan Şirket Kasası hesabıdır.",
    "Update POS": "POS'u Güncelle",
    "New POS Collection": "Yeni POS Tahsilatı",
    "Record a customer card collection.": "Müşteri kart tahsilatını kaydedin.",
    "POS Account": "POS Hesabı",
    "Settlement": "Mutabakat",
    "Gross Amount": "Brüt Tutar",
    "Net Settlement": "Net Mutabakat",
    "Recording the POS collection does not increase Company Cash. Only the net amount enters Company Cash after settlement.": "POS tahsilatını kaydetmek Şirket Kasası'nı artırmaz. Yalnızca net tutar mutabakat sonrasında Şirket Kasası'na girer.",
    "Settle POS Collection?": "POS Tahsilatı Mutabık Hale Getirilsin mi?",
    "COMPANY CASH SETTLEMENT": "COMPANY CASH MUTABAKATI",
    "Settlement account not found": "Mutabakat hesabı bulunamadı",
    "Only the net amount will be posted to Company Cash. Gross amount and POS commission remain separately visible in POS records.": "Yalnızca net tutar Şirket Kasası'na işlenecektir. Brüt tutar ve POS komisyonu POS kayıtlarında ayrı olarak görünmeye devam eder.",
    "Settle Collection": "Tahsilatı Mutabık Hale Getir",
    "Cancel Collection?": "Tahsilat İptal Edilsin mi?",
    "This pending POS collection will be marked as cancelled. It will never increase Company Cash.": "Bu bekleyen POS tahsilatı iptal edildi olarak işaretlenecektir. Şirket Kasası'nı hiçbir zaman artırmayacaktır.",
    "Back": "Geri",
    "Cancel Collection": "Tahsilatı İptal Et",
    "Delete POS Account?": "POS Hesabı Silinsin mi?",
    "A POS account with pending settlements cannot be deleted.": "Bekleyen mutabakatı olan POS hesabı silinemez.",
    "POS accounts could not be loaded.": "POS hesapları yüklenemedi.",
    "POS collections could not be loaded.": "POS tahsilatları yüklenemedi.",
    "POS data could not be loaded.": "POS verileri yüklenemedi.",
    "POS name is required.": "POS adı zorunludur.",
    "Settlement account is required.": "Mutabakat hesabı zorunludur.",
    "Settlement account could not be found.": "Mutabakat hesabı bulunamadı.",
    "POS and settlement account currencies must match.": "POS ve mutabakat hesabının para birimleri aynı olmalıdır.",
    "Settlement account is inactive.": "Mutabakat hesabı pasif.",
    "Commission rate must be between 0 and 100.": "Komisyon oranı 0 ile 100 arasında olmalıdır.",
    "Settlement days must be zero or greater.": "Mutabakat günü sıfır veya daha büyük olmalıdır.",
    "POS account updated successfully.": "POS hesabı başarıyla güncellendi.",
    "POS account created successfully.": "POS hesabı başarıyla oluşturuldu.",
    "POS account could not be saved.": "POS hesabı kaydedilemedi.",
    "This POS account has": "Bu POS hesabında",
    "pending settlement(s) and cannot be deleted.": "bekleyen mutabakat bulunuyor ve silinemez.",
    "POS account deleted successfully.": "POS hesabı başarıyla silindi.",
    "POS account could not be deleted.": "POS hesabı silinemedi.",
    "Inactive POS account cannot receive new collections.": "Pasif POS hesabı yeni tahsilat alamaz.",
    "Please select a POS account.": "Lütfen bir POS hesabı seçin.",
    "Selected POS account could not be found.": "Seçilen POS hesabı bulunamadı.",
    "Net settlement amount cannot be negative.": "Net mutabakat tutarı negatif olamaz.",
    "POS collection recorded successfully. Company Cash has not changed yet.": "POS tahsilatı başarıyla kaydedildi. Şirket Kasası henüz değişmedi.",
    "POS collection could not be created.": "POS tahsilatı oluşturulamadı.",
    "Only pending POS collections can be settled.": "Yalnızca bekleyen POS tahsilatları mutabık hale getirilebilir.",
    "Collection is no longer pending.": "Tahsilat artık bekleyen durumda değil.",
    "POS collection settled successfully. Net amount was added to Company Cash.": "POS tahsilatı başarıyla mutabık hale getirildi. Net tutar Şirket Kasası'na eklendi.",
    "POS collection could not be settled.": "POS tahsilatı mutabık hale getirilemedi.",
    "Only pending POS collections can be cancelled.": "Yalnızca bekleyen POS tahsilatları iptal edilebilir.",
    "POS collection cancelled successfully.": "POS tahsilatı başarıyla iptal edildi.",
    "POS collection could not be cancelled.": "POS tahsilatı iptal edilemedi.",
    "Cancel": "Kapat",
    "CORPORATE TREASURY": "KURUMSAL HAZİNE",
    "Promissory Notes": "Senetler",
    "Manage received and issued promissory notes, maturity dates, portfolio exposure, protests, collections and payments through Company Cash.": "Alınan ve verilen senetleri, vade tarihlerini, portföy riskini, protestoları, tahsilatları ve Şirket Kasası üzerinden yapılan ödemeleri yönetin.",
    "received": "alınan",
    "issued": "verilen",
    "protested": "protestolu",
    "Company Cash accounts": "Şirket Kasası hesabı",
    "RECEIVED NOTE PORTFOLIO": "ALINAN SENET PORTFÖYÜ",
    "Issued exposure": "Verilen senet yükümlülüğü",
    "Add Note": "Senet Ekle",
    "Summary Currency": "Özet Para Birimi",
    "Received Portfolio": "Alınan Senet Portföyü",
    "notes": "senet",
    "Issued Exposure": "Verilen Senet Yükümlülüğü",
    "Due Within 7 Days": "7 Gün İçinde Vadeli",
    "Upcoming promissory note maturities": "Yaklaşan senet vadeleri",
    "Risk / Overdue": "Risk / Gecikme",
    "overdue": "gecikmiş",
    "Promissory Note Portfolio": "Senet Portföyü",
    "Track incoming and outgoing promissory notes, maturities, settlement and protest status.": "Gelen ve giden senetleri, vadeleri, kapatma ve protesto durumlarını takip edin.",
    "Note no, issuer, beneficiary, account...": "Senet no, düzenleyen, lehtar, hesap...",
    "Direction": "Yön",
    "All Directions": "Tüm Yönler",
    "Issued": "Verilen",
    "promissory notes": "senet",
    "Portfolio": "Portföy",
    "Protested": "Protestolu",
    "NOTE": "SENET",
    "DIRECTION": "YÖN",
    "ISSUER": "DÜZENLEYEN",
    "BENEFICIARY": "LEHTAR",
    "ISSUE DATE": "DÜZENLEME TARİHİ",
    "CASH ACCOUNT": "KASA HESABI",
    "Created": "Oluşturuldu",
    "Endorsed": "Ciro Edildi",
    "day overdue": "gün gecikmiş",
    "day remaining": "gün kaldı",
    "Not Settled": "Kapatılmadı",
    "Company Cash posted": "Şirket Kasası'na işlendi",
    "Collect promissory note": "Senedi tahsil et",
    "Pay promissory note": "Senedi öde",
    "Endorsed note cannot be collected into Company Cash": "Ciro edilmiş senet Şirket Kasası'na tahsil edilemez",
    "Protested note cannot be collected into Company Cash": "Protestolu senet Şirket Kasası'na tahsil edilemez",
    "Cancelled note cannot be settled": "İptal edilmiş senet kapatılamaz",
    "Promissory note is already settled": "Senet zaten kapatılmış",
    "Promissory note cannot be settled": "Senet kapatılamaz",
    "Settled note cannot be edited": "Kapatılmış senet düzenlenemez",
    "Edit promissory note": "Senedi düzenle",
    "Settled note cannot be deleted": "Kapatılmış senet silinemez",
    "Delete promissory note": "Senedi sil",
    "Edit Promissory Note": "Senedi Düzenle",
    "Add Promissory Note": "Senet Ekle",
    "Register received or issued promissory note information.": "Alınan veya verilen senet bilgilerini kaydedin.",
    "Note No": "Senet No",
    "Issuer Name": "Düzenleyen Adı",
    "Person/company issuing the promissory note.": "Senedi düzenleyen kişi/şirket.",
    "Person/company that will receive payment.": "Ödemeyi alacak kişi/şirket.",
    "Record Status": "Kayıt Durumu",
    "An endorsed promissory note has been transferred to another party and cannot be collected directly into Company Cash.": "Ciro edilmiş senet başka bir tarafa devredilmiştir ve doğrudan Şirket Kasası'na tahsil edilemez.",
    "A protested promissory note cannot be settled directly into Company Cash until its business/legal status is resolved.": "Protestolu senet, ticari/hukuki durumu çözülmeden doğrudan Şirket Kasası'na kapatılamaz.",
    "A received promissory note does not increase Company Cash when registered. Company Cash increases only when the note is collected.": "Alınan senet kaydedildiğinde Şirket Kasası bakiyesini artırmaz. Bakiye yalnızca senet tahsil edildiğinde artar.",
    "An issued promissory note does not decrease Company Cash when registered. Company Cash decreases only when the note is paid.": "Verilen senet kaydedildiğinde Şirket Kasası bakiyesini azaltmaz. Bakiye yalnızca senet ödendiğinde azalır.",
    "Update Note": "Senedi Güncelle",
    "Collect Promissory Note": "Senedi Tahsil Et",
    "Pay Promissory Note": "Senedi Öde",
    "This operation automatically updates Company Cash.": "Bu işlem Şirket Kasası'nı otomatik olarak günceller.",
    "Selected Company Cash account has insufficient balance for this promissory note payment.": "Seçilen Şirket Kasası hesabında bu senet ödemesi için yeterli bakiye yok.",
    "After confirmation, status becomes Collected and a Company Cash Cash In transaction with payment method Promissory Note is created.": "Onaydan sonra durum Tahsil Edildi olur ve ödeme yöntemi Senet olan bir Şirket Kasası Nakit Giriş işlemi oluşturulur.",
    "After confirmation, status becomes Paid and a Company Cash Cash Out transaction with payment method Promissory Note is created.": "Onaydan sonra durum Ödendi olur ve ödeme yöntemi Senet olan bir Şirket Kasası Nakit Çıkış işlemi oluşturulur.",
    "Collect Note": "Senedi Tahsil Et",
    "Pay Note": "Senedi Öde",
    "Delete Promissory Note?": "Senet Silinsin mi?",
    "Collected or paid promissory notes cannot be deleted because they have already affected Company Cash.": "Tahsil edilmiş veya ödenmiş senetler Şirket Kasası'nı zaten etkilediği için silinemez.",
    "Delete Note": "Senedi Sil",
    "Promissory notes could not be loaded.": "Senetler yüklenemedi.",
    "Settled promissory notes cannot be edited.": "Kapatılmış senetler düzenlenemez.",
    "Promissory note number is required.": "Senet numarası zorunludur.",
    "Promissory note amount must be greater than zero.": "Senet tutarı sıfırdan büyük olmalıdır.",
    "Selected status is not valid for this promissory note direction.": "Seçilen durum bu senet yönü için geçerli değildir.",
    "Promissory note updated successfully.": "Senet başarıyla güncellendi.",
    "Promissory note created successfully.": "Senet başarıyla oluşturuldu.",
    "Promissory note could not be saved.": "Senet kaydedilemedi.",
    "This promissory note cannot be settled in its current status.": "Bu senet mevcut durumunda kapatılamaz.",
    "Endorsed promissory notes cannot be collected directly into Company Cash.": "Ciro edilmiş senetler doğrudan Şirket Kasası'na tahsil edilemez.",
    "Protested promissory notes cannot be collected directly into Company Cash.": "Protestolu senetler doğrudan Şirket Kasası'na tahsil edilemez.",
    "Cancelled promissory notes cannot be settled.": "İptal edilmiş senetler kapatılamaz.",
    "Promissory note can no longer be settled in its current status.": "Senet mevcut durumunda artık kapatılamaz.",
    "Promissory note and Company Cash account currencies must match.": "Senet ile Şirket Kasası hesabının para birimleri aynı olmalıdır.",
    "Selected Company Cash account has insufficient balance.": "Seçilen Şirket Kasası hesabında yeterli bakiye yok.",
    "Promissory note collected successfully and added to Company Cash.": "Senet başarıyla tahsil edildi ve Şirket Kasası'na eklendi.",
    "Promissory note paid successfully and deducted from Company Cash.": "Senet başarıyla ödendi ve Şirket Kasasından düşüldü.",
    "Promissory note could not be settled.": "Senet kapatılamadı.",
    "Collected or paid promissory notes cannot be deleted because they already affected Company Cash.": "Tahsil edilmiş veya ödenmiş senetler Şirket Kasasını etkilediği için silinemez.",
    "Settled promissory note cannot be deleted.": "Kapatılmış senet silinemez.",
    "Promissory note deleted successfully.": "Senet başarıyla silindi.",
    "Promissory note could not be deleted.": "Senet silinemedi.",

    "Reconciliations":
        "Mutabakatlar",

    "ACCOUNT RECONCILIATION":
        "CARİ HESAP MUTABAKATI",

    "Review and confirm balances with customers and service providers from a single financial control center.":
        "Müşteri ve tedarikçi bakiyelerini tek bir finansal kontrol merkezinden inceleyin ve mutabık hale getirin.",

    "TOTAL RECONCILIATIONS":
        "TOPLAM MUTABAKAT",

    "All reconciliation records":
        "Tüm mutabakat kayıtları",

    "CONFIRMED":
        "MUTABIK",

    "Successfully matched":
        "Başarıyla mutabık",

    "WAITING RESPONSE":
        "YANIT BEKLENİYOR",

    "Sent or pending response":
        "Gönderilmiş veya yanıt bekleyen",

    "DISPUTED":
        "UYUŞMAZLIK",

    "Requires finance review":
        "Finans incelemesi gerekli",

    "Sent":
        "Gönderildi",

    "Waiting Response":
        "Yanıt Bekleniyor",

    "Confirmed":
        "Mutabık",

    "Disputed":
        "Uyuşmazlık",

    "Party Type":
        "Cari Tipi",

    "All Parties":
        "Tüm Cari Tipleri",

    "Status":
        "Durum",

    "Reconciliation Filters":
        "Mutabakat Filtreleri",

    "Search and segment reconciliations by account, type, currency and status.":
        "Mutabakatları cari hesap, tip, para birimi ve duruma göre arayın ve filtreleyin.",

    "Account or reconciliation no":
        "Cari hesap veya mutabakat no",

    "Reconciliation Register":
        "Mutabakat Kayıtları",

    "records currently displayed":
        "kayıt görüntüleniyor",

    "Loading reconciliations...":
        "Mutabakatlar yükleniyor...",

    "New Reconciliation":
        "Yeni Mutabakat",

    "Select an account and reporting period to calculate the balance.":
        "Bakiyeyi hesaplamak için cari hesap ve mutabakat dönemini seçin.",

    "Account & Period":
        "Cari Hesap & Dönem",

    "Select the business partner, currency and reconciliation period.":
        "Cari hesabı, para birimini ve mutabakat dönemini seçin.",

    "Period Start":
        "Dönem Başlangıcı",

    "Period End":
        "Dönem Bitişi",

    "Search customer":
        "Müşteri ara",

    "Search service provider":
        "Tedarikçi ara",

    "No customers found":
        "Müşteri bulunamadı",

    "No service providers found":
        "Tedarikçi bulunamadı",

    "Loading customers...":
        "Müşteriler yükleniyor...",

    "Loading service providers...":
        "Tedarikçiler yükleniyor...",

    "Calculate":
        "Hesapla",

    "Reconciliation Preview":
        "Mutabakat Önizleme",

    "Transactions":
        "Hareket",

    "OPENING BALANCE":
        "AÇILIŞ BAKİYESİ",

    "DEBIT TOTAL":
        "TOPLAM BORÇ",

    "CREDIT TOTAL":
        "TOPLAM ALACAK",

    "CLOSING BALANCE":
        "KAPANIŞ BAKİYESİ",

    "RECONCILIATION":
        "MUTABAKAT",

    "ACCOUNT":
        "CARİ HESAP",

    "PERIOD":
        "DÖNEM",

    "DIFFERENCE":
        "FARK",

    "Date":
        "Tarih",

    "Debit":
        "Borç",

    "No transactions found for this period.":
        "Bu dönem için finansal hareket bulunamadı.",

    "Reconciliations could not be fetched.":
        "Mutabakat kayıtları getirilemedi.",

    "Accounts could not be fetched.":
        "Cari hesaplar getirilemedi.",

    "Party type is required.":
        "Cari tipi zorunludur.",

    "Account is required.":
        "Cari hesap zorunludur.",

    "Currency is required.":
        "Para birimi zorunludur.",

    "Period start and end dates are required.":
        "Dönem başlangıç ve bitiş tarihleri zorunludur.",

    "Invalid reconciliation period.":
        "Geçersiz mutabakat dönemi.",

    "Period start cannot be later than period end.":
        "Dönem başlangıcı dönem bitişinden sonra olamaz.",

    "Reconciliation could not be calculated.":
        "Mutabakat hesaplanamadı.",

    "Reconciliation could not be saved.":
        "Mutabakat kaydedilemedi.",

    // Transaction types
    "return_invoice":
        "İade Faturası",

    "collection":
        "Tahsilat",

    "supplier_invoice":
        "Tedarikçi Faturası",

    "supplier_payment":
        "Tedarikçi Ödemesi",

    "opening_balance":
        "Açılış Bakiyesi",

    "adjustment":
        "Düzeltme",

    "RECONCILIATION DETAIL":
        "MUTABAKAT DETAYI",

    "Reconciliation":
        "Mutabakat",

    "Back to Reconciliations":
        "Mutabakatlara Dön",

    "Recalculate":
        "Yeniden Hesapla",

    "Balance before period":
        "Dönem öncesi bakiye",

    "Period debit movements":
        "Dönem borç hareketleri",

    "Period credit movements":
        "Dönem alacak hareketleri",

    "Calculated system balance":
        "Hesaplanan sistem bakiyesi",

    "Counterparty balance not entered":
        "Karşı taraf bakiyesi girilmedi",

    "Balances match":
        "Bakiyeler eşleşiyor",

    "Requires review":
        "İnceleme gerekli",

    "Account Statement":
        "Cari Hesap Ekstresi",

    "Snapshot of all transactions included in this reconciliation":
        "Bu mutabakata dahil edilen tüm finansal hareketlerin anlık görüntüsü",

    "No transactions found":
        "Finansal hareket bulunamadı",

    "No financial activity was included in this reconciliation period.":
        "Bu mutabakat dönemine dahil edilmiş finansal hareket bulunmamaktadır.",

    "Balance Confirmation":
        "Bakiye Teyidi",

    "Compare system balance with counterparty confirmation.":
        "Sistem bakiyesini karşı tarafın bildirdiği bakiye ile karşılaştırın.",

    "Counterparty Balance":
        "Karşı Taraf Bakiyesi",

    "System Balance":
        "Sistem Bakiyesi",

    "Counterparty":
        "Karşı Taraf",

    "System and counterparty balances match.":
        "Sistem ve karşı taraf bakiyeleri eşleşiyor.",

    "Balance difference detected. Review the account statement before confirmation.":
        "Bakiye farkı tespit edildi. Mutabakatı onaylamadan önce cari hesap ekstresini kontrol edin.",

    "Internal Notes":
        "Dahili Notlar",

    "Dispute Note":
        "Uyuşmazlık Notu",

    "Status Note":
        "Durum Notu",

    "Save Changes":
        "Değişiklikleri Kaydet",

    "Reconciliation Workflow":
        "Mutabakat İş Akışı",

    "Current workflow status and available actions.":
        "Mevcut mutabakat durumu ve kullanılabilir işlemler.",

    "Current Status":
        "Mevcut Durum",

    "Change Status":
        "Durumu Değiştir",

    "No further workflow actions are available.":
        "Bu mutabakat için başka bir iş akışı işlemi bulunmuyor.",

    "Record Information":
        "Kayıt Bilgileri",

    "Created At":
        "Oluşturulma Tarihi",

    "Created By":
        "Oluşturan",

    "Last Calculated":
        "Son Hesaplama",

    "Last Updated":
        "Son Güncelleme",

    "Update Reconciliation Status":
        "Mutabakat Durumunu Güncelle",

    "Review the status change before confirming.":
        "Onaylamadan önce durum değişikliğini kontrol edin.",

    "New Status":
        "Yeni Durum",

    "CONFIRMATION CONTROL":
        "MUTABAKAT KONTROLÜ",

    "Balances must match before this reconciliation can be confirmed.":
        "Mutabakatın onaylanabilmesi için sistem ve karşı taraf bakiyeleri eşit olmalıdır.",

    "Update Status":
        "Durumu Güncelle",

    "Loading reconciliation...":
        "Mutabakat yükleniyor...",

    "Reconciliation could not be fetched.":
        "Mutabakat getirilemedi.",

    "Reconciliation could not be found.":
        "Mutabakat bulunamadı.",

    "Reconciliation details saved successfully.":
        "Mutabakat bilgileri başarıyla kaydedildi.",

    "Reconciliation could not be updated.":
        "Mutabakat güncellenemedi.",

    "Reconciliation recalculated successfully.":
        "Mutabakat başarıyla yeniden hesaplandı.",

    "Reconciliation could not be recalculated.":
        "Mutabakat yeniden hesaplanamadı.",

    "Reconciliation status updated successfully.":
        "Mutabakat durumu başarıyla güncellendi.",

    "Reconciliation status could not be updated.":
        "Mutabakat durumu güncellenemedi.",

    "Reconciliation PDF generated successfully.":
        "Mutabakat PDF'i başarıyla oluşturuldu.",

    "Reconciliation PDF could not be generated.":
        "Mutabakat PDF'i oluşturulamadı.",
    

    "Reconciliation PDF could not be opened.":
        "Mutabakat PDF'i açılamadı.",

    "Generated PDF file is empty.":
        "Oluşturulan PDF dosyası boş.",

    // Reconciliation Detail

    "Balance Date": "Bakiye Tarihi",
    "Balance as of": "Bakiye Tarihi",
    "Send": "Gönder",

    "CURRENT BALANCE": "GÜNCEL BAKİYE",
    "COUNTERPARTY BALANCE": "KARŞI TARAF BAKİYESİ",
    "Balance declared by counterparty": "Karşı tarafın bildirdiği bakiye",

    "Balance Summary": "Bakiye Özeti",
    "Current balance calculated from all records up to the selected balance date.":
        "Seçilen bakiye tarihine kadar olan tüm kayıtlardan hesaplanan güncel bakiye.",

    "Counterparty Information": "Cari Hesap Bilgileri",
    "Reconciliation counterparty details": "Mutabakat cari hesap bilgileri",

    "Company": "Firma",
    "Tax Number": "Vergi Numarası",
    "Address": "Adres",

    "Enter the balance declared by the counterparty.":
        "Karşı tarafın bildirdiği bakiyeyi giriniz.",

    "Current System Balance": "Sistem Güncel Bakiyesi",
    "Difference": "Fark",

    "Send Reconciliation": "Mutabakat Gönder",
    "Send the reconciliation PDF to the counterparty.":
        "Mutabakat PDF'ini karşı tarafa gönderin.",

    "Recipient Email": "Alıcı E-posta Adresi",
    "Language": "Dil",
    "CC": "Bilgi",
    "Subject": "Konu",
    "Message": "Mesaj",

    "PDF Attachment": "PDF Eki",
    "The PDF will be generated automatically using the selected language.":
        "PDF, seçilen dile göre otomatik olarak oluşturulacaktır.",


    "Sending...": "Gönderiliyor...",
    "Send Email": "E-posta Gönder",


    "Recipient email is required.": "Alıcı e-posta adresi zorunludur.",
    "Recipient email address is invalid.": "Alıcı e-posta adresi geçersizdir.",
    "Subject is required.": "Konu alanı zorunludur.",
    "Message is required.": "Mesaj alanı zorunludur.",

    "Reconciliation sent by email.": "Mutabakat e-posta ile gönderildi.",
    "Reconciliation email sent successfully.": "Mutabakat e-postası başarıyla gönderildi.",
    "Reconciliation email could not be sent.": "Mutabakat e-postası gönderilemedi.",

    "Please select a status.": "Lütfen bir durum seçiniz.",
    "A dispute note is required.": "Uyuşmazlık notu zorunludur.",
    "Reconciliation with a balance difference cannot be confirmed.":
        "Bakiye farkı bulunan mutabakat onaylanamaz.",

    // Reconciliations List
    "BALANCE DATE": "BAKİYE TARİHİ",

    "Balance date is required.": "Bakiye tarihi zorunludur.",
    "Invalid balance date.": "Geçersiz bakiye tarihi.",


    "Select an account and balance date to calculate all financial movements up to that date.":
        "Belirtilen tarihe kadar olan tüm finansal hareketleri hesaplamak için cari hesap ve bakiye tarihini seçin.",

    "Account & Balance Date": "Cari Hesap ve Bakiye Tarihi",
    "Select the account, currency and date to calculate the balance up to that date.":
        "Belirtilen tarihe kadar olan bakiyeyi hesaplamak için cari hesap, para birimi ve tarih seçin.",

    "Balance including all records up to the selected date.":
        "Seçilen tarihe kadar olan tüm kayıtlar dahil güncel bakiye.",


    "No transactions found up to the selected balance date.":
        "Seçilen bakiye tarihine kadar hareket bulunamadı.",


    // Return invoice pages (ReturnInvoice / ReturnInvoiceDetail)
    "The request could not be completed.": "İstek tamamlanamadı.",
    "Original invoice ID is missing. Open this page from an invoice detail screen.":
        "Orijinal fatura ID'si eksik. Bu sayfayı bir fatura detay ekranından açın.",
    "Returnable invoice data is invalid.": "İade edilebilir fatura verisi geçersiz.",
    "Returnable invoice could not be loaded.": "İade edilebilir fatura yüklenemedi.",
    "Excel export could not be created. Make sure the xlsx package is installed.":
        "Excel dışa aktarımı oluşturulamadı. xlsx paketinin yüklü olduğundan emin olun.",
    "Loading returnable invoice...": "İade edilebilir fatura yükleniyor...",
    "FINANCE RETURN OPERATIONS": "FİNANS İADE İŞLEMLERİ",
    "Create a full or partial return from the remaining quantities of the original invoice.":
        "Orijinal faturanın kalan miktarlarından tam veya kısmi iade oluşturun.",
    "Draft Return Invoice": "Taslak İade Faturası",
    "This invoice has no remaining returnable amount.": "Bu faturanın kalan iade edilebilir tutarı bulunmuyor.",
    "Original Invoice": "Orijinal Fatura",
    "Source invoice and remaining return capacity": "Kaynak fatura ve kalan iade kapasitesi",
    "Original Total": "Orijinal Toplam",
    "Reserved / Returned": "Rezerve / İade Edilen",
    "Remaining Returnable": "Kalan İade Edilebilir",
    "Return Information": "İade Bilgileri",
    "Select the return type and provide a mandatory reason": "İade tipini seçin ve zorunlu iade nedenini belirtin",
    "Return Type": "İade Tipi",
    "Full Remaining Return": "Kalanın Tamamının İadesi",
    "Return Invoice Date": "İade Fatura Tarihi",
    "Due Date": "Vade Tarihi",
    "Original Invoice No": "Orijinal Fatura No",
    "Return Reason": "İade Nedeni",
    "Return Items": "İade Kalemleri",
    "Price, currency and VAT are locked to the original invoice.":
        "Fiyat, para birimi ve KDV orijinal faturaya kilitlidir.",
    "Quantity Based": "Miktar Bazlı",
    "Amount Based": "Tutar Bazlı",
    "Select or clear every returnable row": "İade edilebilir tüm satırları seç veya temizle",
    "Clear All": "Tümünü Temizle",
    "Select All": "Tümünü Seç",
    "Excel Export": "Excel'e Aktar",
    "All remaining selected": "Kalanın tamamı seçildi",
    "selected": "seçildi",
    "Original Qty": "Orijinal Miktar",
    "Remaining Qty": "Kalan Miktar",
    "Remaining Amount": "Kalan Tutar",
    "Return Qty": "İade Miktarı",
    "Return Amount": "İade Tutarı",
    "Return Total": "İade Toplamı",
    "Select": "Seç",
    "The backend recalculates every return line from the original invoice. Unit price, VAT, currency and totals shown here are previews and are not submitted as authoritative values.":
        "Sunucu, her iade satırını orijinal faturadan yeniden hesaplar. Burada gösterilen birim fiyat, KDV, para birimi ve toplamlar önizlemedir ve kesin değer olarak gönderilmez.",
    "Return Summary": "İade Özeti",
    "The selected total exceeds the remaining returnable amount.": "Seçilen toplam, kalan iade edilebilir tutarı aşıyor.",
    "Creating...": "Oluşturuluyor...",
    "Create Return Draft": "İade Taslağı Oluştur",
    "Original invoice could not be found.": "Orijinal fatura bulunamadı.",
    "Return type is required.": "İade tipi zorunludur.",
    "Return reason is required.": "İade nedeni zorunludur.",
    "Return invoice date is required.": "İade fatura tarihi zorunludur.",
    "Select at least one invoice item.": "En az bir fatura kalemi seçin.",
    'Return quantity for "': 'İade miktarı: "',
    '" is invalid.': '" için geçersiz.',
    "Return total must be greater than zero.": "İade toplamı sıfırdan büyük olmalıdır.",
    "Return total exceeds the remaining returnable amount.": "İade toplamı, kalan iade edilebilir tutarı aşıyor.",
    "Return invoice draft created successfully.": "İade faturası taslağı başarıyla oluşturuldu.",
    "Return invoice could not be created.": "İade faturası oluşturulamadı.",

    "Request failed.": "İstek başarısız oldu.",
    "Return invoice ID is missing.": "İade fatura ID'si eksik.",
    "Return invoice data is invalid.": "İade fatura verisi geçersiz.",
    "Return invoice could not be loaded.": "İade faturası yüklenemedi.",
    "Return invoice data is missing.": "İade fatura verisi eksik.",
    "Updated return invoice PDF could not be uploaded.": "Güncellenen iade faturası PDF'i yüklenemedi.",
    "PDF upload response did not include filePath.": "PDF yükleme yanıtı dosya yolunu içermiyor.",
    "Return invoice approved successfully.": "İade faturası başarıyla onaylandı.",
    "The e-mail to the customer could not be sent": "Müşteriye e-posta gönderilemedi",
    "Return invoice issued successfully.": "İade faturası başarıyla kesildi.",
    "Return invoice cancelled successfully.": "İade faturası başarıyla iptal edildi.",
    "Return invoice was approved, but the updated PDF URL was not returned.":
        "İade faturası onaylandı ancak güncellenen PDF adresi döndürülmedi.",
    "Status could not be updated.": "Durum güncellenemedi.",
    "This return invoice was already sent to EDM.": "Bu iade faturası zaten EDM'ye gönderildi.",
    "Return invoice sent to EDM successfully": "İade faturası EDM'ye başarıyla gönderildi",
    "Return invoice could not be sent to EDM.": "İade faturası EDM'ye gönderilemedi.",
    "Loading return invoice...": "İade faturası yükleniyor...",
    "Return Invoice Detail": "İade Fatura Detayı",
    "Review returned items, totals and document status.": "İade edilen kalemleri, toplamları ve belge durumunu inceleyin.",
    "Approve": "Onayla",
    "Issue": "Kes",
    "Send to EDM": "EDM'ye Gönder",
    "This invoice had already reached EDM from an earlier attempt; its status was reconciled instead of resending.":
        "Bu fatura daha önceki bir denemede EDM'ye zaten ulaşmıştı; tekrar gönderilmek yerine durumu güncellendi.",
    "This return invoice is cancelled and no longer affects the original invoice balance.":
        "Bu iade faturası iptal edilmiştir ve artık orijinal fatura bakiyesini etkilemez.",
    "Return Subtotal": "İade Ara Toplamı",
    "Document Information": "Belge Bilgileri",
    "Return Invoice No.": "İade Fatura No.",
    "Original Invoice No.": "Orijinal Fatura No.",
    "Issued At": "Kesim Tarihi",
    "Updated At": "Güncellenme Tarihi",
    "No return reason provided.": "İade nedeni belirtilmemiş.",
    "Returned Items": "İade Edilen Kalemler",
    "Prices and VAT are inherited from the original invoice.": "Fiyatlar ve KDV orijinal faturadan devralınmıştır.",
    "No returned item found.": "İade edilen kalem bulunamadı.",
    "Approve return invoice?": "İade faturası onaylansın mı?",
    "Issue return invoice?": "İade faturası kesilsin mi?",
    "Cancel return invoice?": "İade faturası iptal edilsin mi?",
    "The return will be validated and made ready for issuing.": "İade doğrulanacak ve kesilmeye hazır hale getirilecektir.",
    "The return will be applied to the original invoice balance after it is issued.":
        "İade, kesildikten sonra orijinal fatura bakiyesine yansıtılacaktır.",
    "The return will stop affecting the original invoice balance after cancellation.":
        "İptal edildikten sonra iade, orijinal fatura bakiyesini etkilemeyi durduracaktır.",
    "Keep Current Status": "Mevcut Durumu Koru",
    "Confirm": "Onayla",
    "Retry": "Tekrar Dene",

    // EDM GİB status check (Send to EDM only confirms EDM received the
    // document — this separately checks GİB's own acceptance/rejection)
    "GİB status": "GİB durumu",
    "Unknown": "Bilinmiyor",
    "GİB status could not be checked.": "GİB durumu kontrol edilemedi.",
    "Last checked GİB status": "Son kontrol edilen GİB durumu",
    "GİB has not been checked yet — a successful send only confirms EDM received it.":
        "GİB durumu henüz kontrol edilmedi — başarılı gönderim sadece EDM'in belgeyi aldığını doğrular.",
    "Checking...": "Kontrol ediliyor...",
    "Check GİB Status": "GİB Durumunu Kontrol Et",

    // Incoming Invoices page (EDM GetInvoice, DIRECTION=IN)
    "Amount": "Tutar",
    "Incoming Invoices": "Gelen Faturalar",
    "Invoices received through EDM (e-Fatura / e-Arşiv addressed to this company)":
        "EDM üzerinden alınan faturalar (bu şirkete kesilen e-Fatura / e-Arşiv)",
    "Incoming invoices could not be loaded.": "Gelen faturalar yüklenemedi.",
    "EDM only allows a 2-month range per query.": "EDM sorgu başına en fazla 2 aylık tarih aralığına izin veriyor.",
    "EDM INCOMING INVOICE CENTER": "EDM GELEN FATURA MERKEZİ",
    "Status guide": "Durum rehberi",
    "What each EDM status on this page means": "Bu sayfadaki her EDM durumunun anlamı",
    "Accepted": "Kabul Edildi",
    "Invoice reached the recipient, no decision yet": "Fatura alıcıya ulaştı, henüz karar verilmedi",
    "Recipient approved the invoice": "Alıcı faturayı onayladı",
    "Recipient rejected or cancelled the invoice": "Alıcı faturayı reddetti veya iptal etti",
    "Awaiting a decision from the recipient": "Alıcıdan karar bekleniyor",
    "Linked": "Bağlandı",
    "Total Invoices": "Toplam Fatura",
    "Awaiting Link": "Bağlanmayı Bekliyor",
    "Link to Job": "İşe Bağla",
    "Job / Shipment No": "İş / Sevkiyat No",
    "Job / shipment number is required.": "İş / sevkiyat numarası zorunludur.",
    "Select a job to link this invoice to.": "Bu faturayı bağlamak için bir iş seçin.",
    "Match Open Job": "Açık İşten Eşleştir",
    "Manual Entry": "Manuel Giriş",
    "Change": "Değiştir",
    "Search by job no, customer or supplier...": "İş no, müşteri veya tedarikçiye göre ara...",
    "No open jobs found": "Açık iş bulunamadı",
    "Try manual entry instead.": "Bunun yerine manuel giriş deneyin.",
    "Open jobs could not be loaded.": "Açık işler yüklenemedi.",
    "expected": "beklenen",
    "Selling": "Satış",
    "Invoice matches the TMS cost within tolerance; job cost updated from supplier invoices for job": "Fatura TMS maliyetiyle tolerans içinde eşleşti; maliyet tedarikçi faturalarından güncellendi, iş",
    "Amounts are VAT-exclusive, in the job's cost currency. Until approved, the job keeps its TMS cost; once approved, the invoiced total replaces it.": "Tutarlar KDV hariç ve işin maliyet para birimindedir. Onaylanana kadar iş TMS maliyetini korur; onaylanınca fatura toplamı maliyetin yerine geçer.",
    "Unknown Job": "Bilinmeyen İş",
    "Unknown Customer": "Bilinmeyen Müşteri",
    "This incoming invoice could not be linked.": "Bu gelen fatura bağlanamadı.",
    "Save": "Kaydet",
    "Link Incoming Invoice": "Gelen Faturayı Bağla",
    "Select an invoice to link.": "Bağlamak için bir fatura seçin.",
    "Link an EDM incoming invoice to this job.": "Bu işe bir EDM gelen faturasını bağlayın.",
    "No matching incoming invoices found.": "Eşleşen gelen fatura bulunamadı.",
    "Search by supplier or invoice no...": "Tedarikçi veya fatura no'ya göre ara...",
    "Link": "Bağla",

    // Cross-reference summaries on the finance job detail page's Customer
    // Invoices / Supplier Invoices tabs (each tab now shows a compact
    // summary of the other side, not just its own data)
    "Supplier side": "Tedarikçi tarafı",
    "Customer side": "Müşteri tarafı",
    "invoice(s)": "fatura",
    "View Supplier Invoices": "Tedarikçi Faturalarını Gör",
    "View Customer Invoices": "Müşteri Faturalarını Gör",
    "Invoiced": "Faturalanan",
    "No incoming invoices found for this date range.": "Bu tarih aralığında gelen fatura bulunamadı.",

    // Cost-mismatch warning shown after linking a supplier invoice, when the
    // job's total invoiced amount diverges from SupplierCost.expectedAmount
    // beyond its tolerance — the two were never compared anywhere before.
    "Cost Mismatch Warning": "Maliyet Uyuşmazlığı Uyarısı",
    "Job": "İş",
    "invoiced amount differs from the expected cost by": "faturalanan tutar beklenen maliyetten",
    "exceeds the": "kadar sapıyor — tanımlı",
    "tolerance limit.": "tolerans sınırını aşıyor.",
    "Understood": "Anladım",
    "Just Note It": "Sadece Not Et",
    "Approve and Update Cost": "Onayla ve Maliyeti Güncelle",
    "Updating...": "Güncelleniyor...",
    "Cost could not be updated.": "Maliyet güncellenemedi.",
    "Cost updated to match the invoiced amount for job": "Maliyet, faturalanan tutarla eşleşecek şekilde güncellendi — iş",
    "Invoice deleted successfully.": "Fatura başarıyla silindi.",
    "Issued, collected or returned invoices cannot be deleted. Cancel the invoice instead.":
        "Kesilmiş, tahsilatı yapılmış veya iade bağlı faturalar silinemez — bunun yerine faturayı iptal edin.",

    "Update this manual invoice, its attached PDF and its notes.":
        "Bu manuel faturayı, ekli PDF'ini ve notlarını güncelleyin.",
    "This invoice is already issued. Its line items, discount and currencies are locked; you can still update dates, notes, addresses and the attached PDF.":
        "Bu fatura zaten kesildi. Kalemleri, indirimi ve para birimleri kilitlidir; tarihleri, notları, adresleri ve ekli PDF'i güncelleyebilirsiniz.",
    // Detaylı analiz bölümü (FinanceDetailsSection)
    "Detailed analysis": "Detaylı analiz",
    "Charts and breakdowns for the current filters": "Seçili filtrelere göre grafikler ve kırılımlar",
    "Show analysis": "Analizi göster",
    "Hide analysis": "Analizi gizle",
    "e-Invoice (EDM) Status": "e-Fatura (EDM) Durumu",
    "Not sent": "Gönderilmedi",
    "Send failed": "Gönderim hatası",
    "Rejected by GİB": "GİB reddetti",
    "Not applicable": "Kapsam dışı",
    "Accepted by EDM": "EDM tarafından kabul edildi",
    "Issued, waiting to be sent": "Kesildi, gönderilmeyi bekliyor",
    "EDM returned an error": "EDM hata döndürdü",
    "Last GİB check reported a rejection": "Son GİB sorgusu red bildirdi",
    "Draft, cancelled, purchase or return document": "Taslak, iptal, alış veya iade belgesi",
    "EDM Status": "EDM Durumu",
    "EDM Profile": "EDM Profili",
    "All EDM statuses": "Tüm EDM durumları",
    "All profiles": "Tüm profiller",
    "Sent rate": "Gönderim oranı",
    "Filtered": "Filtrelendi",
    "issued sales invoices in the current filters": "kesilmiş satış faturası (mevcut filtrelerde)",
    "click a card to filter the table": "tabloyu filtrelemek için bir karta tıklayın",
    "Waiting to be sent": "Gönderilmeyi bekliyor",
    "Retry from the actions column": "İşlemler sütunundan yeniden deneyin",
    "EDM STATUS": "EDM DURUMU",
    "Invoices not sent to EDM": "EDM'ye gönderilmeyen faturalar",
    "issued, waiting to be sent": "kesildi, gönderim bekliyor",

    "Gross revenue": "Brüt gelir",
    "Returns issued": "Kesilen iadeler",
    "Excluding VAT, after issued returns": "KDV hariç, kesilen iadeler düşülmüş",
    "Open in new tab": "Yeni sekmede aç",
    "Download": "İndir",
    "Loading invoice…": "Fatura yükleniyor…",
    "Invoice could not be loaded.": "Fatura yüklenemedi.",
    "TOTAL TRY": "TOPLAM TL",
    "At today's rate": "Güncel kur",
};

export default tr;
